<!-- 幸运抽奖 -->
<template>
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button type="blue"
        :styleTextObj="{ width: '44px', height: '24px', 'line-height': '24px', padding: '0 8px', 'min-width': '44px' }"
        @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>


      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px;">云短信CRM ：订购到期时间 {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip>
        <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="140px">
          <jd-title label='参与方式' type="bold"></jd-title>
          <el-form-item label="参与方式:" required>
            <div>
              <div><el-radio @change="ruleForm.ruleDTO.plusObject = 0; ruleForm.ruleDTO.orderTimeType = 0" v-model="ruleForm.ruleDTO.joinType"
                  :label="0" :disabled="activityData.isStart">用户报名参与(消费者需要提前报名，报名成功后在购物时间段内支付的订单累计购物进度，未报名不累计)</el-radio>
              </div>
              <div><el-radio @change="ruleForm.ruleDTO.plusObject = 0; ruleForm.ruleDTO.orderTimeType = 0" v-model="ruleForm.ruleDTO.joinType"
                  :label="1"
                  :disabled="activityData.isStart">免报名参与(消费者无需报名活动，活动期间进入活动时，自动判断人群条件，符合后自动参与，累计购物进度)</el-radio>
              </div>
              <div class="rule_box" v-if="ruleForm.ruleDTO.joinType == '0'">
                <el-form-item label-width="120px" label="报名时间范围:" required>用户在
                  <div class="my_select_time">
                    <el-date-picker prefix-icon="no_icon" v-model="ruleForm.ruleDTO.joinStartTime" type="datetime" placeholder="开始日期"
                      size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px" class="time1"
                      :picker-options="joinTimePickerOptionsValue"
                      :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)" :clearable="false"
                      :disabled="joinStartTimeDisabled">
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker prefix-icon="no_icon" v-model="ruleForm.ruleDTO.joinEndTime" type="datetime" placeholder="结束日期"
                      size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 200px; font-size: 12px" class="time2"
                      :picker-options="joinTimePickerOptionsValueEnd"
                      :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                      :disabled="joinEndTimeDisabled"
                      :clearable="false">
                    </el-date-picker>
                    <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="ruleForm.ruleDTO.joinStartTime = '';ruleForm.ruleDTO.joinEndTime = ''"></i>
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
                  </div>
                  期间内报名 <jd-button @click="ruleForm.ruleDTO.joinStartTime = ruleForm.startTime;ruleForm.ruleDTO.joinEndTime = ruleForm.endTime" type="blueText" :disabled="activityData.isStart">同步活动时间</jd-button>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <informationForm
            @selectPeopleSure="selectPeopleSure" 
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime="activityStartTime" 
            :defaultActivityEndTime="activityEndTime" 
            ref="informationForm" 
            v-model="ruleForm"
            :plusObject.sync="ruleForm.ruleDTO.plusObject" 
            :cusType.sync="ruleForm.ruleDTO.cusType" 
            :isCheckOpenCardTime.sync="ruleForm.ruleDTO.isCheckOpenCardTime" 
            :openCardStartTime.sync="ruleForm.ruleDTO.openCardStartTime" 
            :openCardEndTime.sync="ruleForm.ruleDTO.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            :disabled="activityData.isStart" 
            :localStepNum="localStepNum" 
            :needNonMember="true" 
            :isNeedCusType="true"
            :activityId="activityData.id"
            :newOrderWareList.sync="newOrderWareList"
            :plusObjectDistype="ruleForm.ruleDTO.joinType == '1'"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <jd-title label='活动设置' type="bold"></jd-title>
          <el-form-item label="订单要求:" required>
            <div>
              <div>用户所下订单需满足以下条件</div>
              <div class="rule_box">
                <el-form-item label="下单店铺:" required>
                  <div class="flexc">
                    <el-checkbox-group v-model="ruleForm.ruleDTO.venderIds" @change="checkShopChange">
                      <el-checkbox :label="item.venderId" v-for="item in shopList" :key="item.venderId" :disabled="(item.venderId==venderId)||activityData.isStart">{{item.shopTitle}}</el-checkbox>
                      <el-tooltip effect="light" placement="top">
                        <template #content>
                          <div>
                            1.当前店铺默认勾选，且不可取消勾选；
                          </div>
                          <div>
                            2.仅展示当前账号有权限且为同一会员体系下的店铺；
                          </div>
                          <div>
                            3.多店情况下，①如统计规则为【单笔订单满】则表示用户在任意店铺的一笔订单满足条件即可，比如用户在A店有一笔订单满足条件，B店有两笔订单满足条件，则会根据下单时间选取符合条件中最早的一笔订单；②如统计规则为【累计订单满】则表示用户在任意店铺下单均会被累计，比如用户在A店、B店都有下单，则均会统计在内；
                          </div>
                          <div>
                            4.多店铺时，统计单位不支持选择【自定义计量单位】;
                          </div>
                        </template>
                        <el-button type="text" style="width: 35px;">
                          <i class="el-icon-question grey-color"></i>
                        </el-button>
                      </el-tooltip>
                    </el-checkbox-group>
                  </div>
                </el-form-item>
                <el-form-item label="下单时间:" required>
                  <div style="display: flex;flex-wrap: nowrap;">
                    <el-select v-if="ruleForm.ruleDTO.joinType == '0'" style="width: 140px;margin-right: 8px;"
                      :disabled="activityData.isStart" v-model="ruleForm.ruleDTO.orderTimeType" placeholder="">
                      <el-option label="用户在指定时间" :value="0"></el-option>
                      <el-option label="用户在报名后" :value="1"></el-option>
                    </el-select>
                    <div v-if="ruleForm.ruleDTO.orderTimeType == '0'">
                      <div class="my_select_time">
                        <el-date-picker prefix-icon="no_icon" v-model="ruleForm.ruleDTO.orderStartTime" type="datetime"
                          placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss" style="width: 185px; font-size: 12px" class="time1"
                          :picker-options="orderPickerOptionsValue"
                          :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                          :clearable="false" :disabled="activityData.isStart">
                        </el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker prefix-icon="no_icon" v-model="ruleForm.ruleDTO.orderEndTime" type="datetime"
                          placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px; font-size: 12px" class="time2"
                          :picker-options="orderPickerOptionsValueEnd"
                          :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                          :disabled="activityData.isStart"
                          :clearable="false">
                        </el-date-picker>
                        <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart"
                          @click="ruleForm.ruleDTO.orderStartTime = '';ruleForm.ruleDTO.orderEndTime = ''"></i>
                        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
                      </div>
                      期间内下单 <jd-button @click="ruleForm.ruleDTO.orderStartTime = ruleForm.startTime;ruleForm.ruleDTO.orderEndTime = ruleForm.endTime" type="blueText" :disabled="activityData.isStart">同步活动时间</jd-button>
                    </div>
                    <div v-if="ruleForm.ruleDTO.orderTimeType == '1'">
                      <el-input v-model="ruleForm.ruleDTO.orderTime" :disabled="activityData.isStart" placeholder=""
                        @input="(e) => (ruleForm.ruleDTO.orderTime = validateInputNew(e))"
                        style="width: 100px;margin: 0 4px;"></el-input>
                      <el-select style="width: 100px;margin-right: 8px;" v-model="ruleForm.ruleDTO.signOrderTimeType"
                        :disabled="activityData.isStart" placeholder="">
                        <el-option label="天" :value="0"></el-option>
                        <el-option label="小时" :value="1"></el-option>
                        <el-option label="分钟" :value="2"></el-option>
                      </el-select>
                      期间内下单（不可超出活动结束时间）
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="金额统计类型:" required>
                  <div>
                    <div>
                      <el-radio-group
                        v-model="ruleForm.ruleDTO.orderPaymentType"
                        :disabled="activityData.isStart"
                      >
                        <el-radio :label="1">
                          <span>订单金额（后台价）</span>
                          <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                            <div class="new-icon-box" style="margin: -3px 8px"></div>
                          </el-tooltip>
                        </el-radio>
                        <el-radio :label="0" v-if="!isVenderType">
                          <span>用户应付金额</span>
                          <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                            <div class="new-icon-box" style="margin: -3px 8px"></div>
                          </el-tooltip>
                        </el-radio>
                        <el-radio :label="2" v-if="!isVenderType">
                          <span>用户实付金额</span>
                          <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                            <div class="new-icon-box" style="margin: -3px 8px"></div>
                          </el-tooltip>
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div style="color: red;">注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。</div>
                  </div>
                </el-form-item>
                <el-form-item label="统计单位:" required>
                  <el-radio-group v-model="ruleForm.ruleDTO.measureUnitId" :disabled="activityData.isStart" @change="unitChange">
                    <el-radio :label="null">满额有礼</el-radio>
                    <el-radio :label="item.id" v-for="item,index in unitList" :disabled="item.status == 0||ruleForm.ruleDTO.venderIds.length>1" :key="index">满{{item.name || ""}}有礼</el-radio>
                  </el-radio-group>
                  <jd-tip>
                    支持自定义“箱、罐、瓶....”等计量单位，<span class="goToMeasureUnitText" @click="goToMeasureUnit">去设置计量单位></span>
                  </jd-tip>
                </el-form-item>
                <el-form-item label="商品要求:">
                  <template v-if="ruleForm.ruleDTO.measureUnitId == null">
                    <el-radio @change="handleFilterType" v-model="ruleForm.ruleDTO.filterType" :label="0"
                      :disabled="activityData.isStart">全部商品</el-radio>
                    <el-radio @change="handleFilterType" v-model="ruleForm.ruleDTO.filterType" :label="1"
                      :disabled="activityData.isStart">指定商品</el-radio>
                    <el-radio @change="handleFilterType" v-model="ruleForm.ruleDTO.filterType" :label="2"
                      :disabled="activityData.isStart">排除商品</el-radio>
                  </template>
                  <el-radio v-else v-model="ruleForm.ruleDTO.filterType" :label="1" :disabled="activityData.isStart">指定计量单位商品</el-radio>
                  <jd-button v-if="ruleForm.ruleDTO.venderIds.length==1&&ruleForm.ruleDTO.venderIds.includes(venderId)" @click="orderSelectGoods(venderId)" v-loading="skuIdListLoading"
                    :disabled="activityData.isStart || ruleForm.ruleDTO.filterType == 0">
                    已选择
                    {{ ruleForm.ruleDTO.sellerSkuList.length ? ruleForm.ruleDTO.sellerSkuList[0].skuIds.length : 0 }}个
                  </jd-button>
                  <div v-else-if="ruleForm.ruleDTO.venderIds.length>1&&ruleForm.ruleDTO.filterType!=0">
                    <div v-for="item in ruleForm.ruleDTO.sellerSkuList" :key="item.venderId">
                      <div class="flexc-cen-x mb8">
                        <div class="shoptitle-label">{{getTitle(item.venderId)}}</div>
                        <jd-button @click="orderSelectGoods(item.venderId)" v-loading="skuIdListLoading"
                          :disabled="activityData.isStart">
                          已选择
                          {{item.skuIds.length }}个
                        </jd-button>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="指定商品规则:" v-if="ruleForm.ruleDTO.orderPaymentType==1&&ruleForm.ruleDTO.filterType == 1">
                  <el-select style="width: 280px;" v-model="ruleForm.ruleDTO.filterSkuType" :disabled="activityData.isStart" placeholder="">
                    <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                    <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                  </el-select>
                  <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                </el-form-item>
                <!-- 指定商品显示配置：仅在指定商品/排除商品时显示 -->
                <el-form-item label="指定商品显示:" v-if="ruleForm.ruleDTO.filterType == 1 || ruleForm.ruleDTO.filterType == 2">
                  <el-checkbox 
                    v-model="ruleForm.ruleDTO.showProductConditon" 
                    :disabled="activityData.isStart">
                    C端不显示指定或排除的商品
                  </el-checkbox>
                </el-form-item>
                <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.ruleDTO.mergeOrder"
                  >
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                  <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                </el-form-item>
                <el-form-item label="订单状态:" required>
                  <el-radio v-model="ruleForm.ruleDTO.orderType" :label="1" :disabled="activityData.isStart">已完成</el-radio>
                  <el-radio v-model="ruleForm.ruleDTO.orderType" :label="0"
                    :disabled="activityData.isStart">已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio>
                </el-form-item>
                <el-form-item label="手动输入订单：">
                  <el-checkbox v-model="ruleForm.ruleDTO.isSupportManualInputOrder" :disabled="activityData.isStart">
                    支持手动输入订单（自动同步订单会稍微延迟，C端用户可用输入订单号快速同步订单）
                  </el-checkbox>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <jd-title label='奖品设置' type="bold"></jd-title>
          <el-form-item label="发放规则:" required>
            <div style="display: flex;align-items: center;">
              <el-radio v-model="ruleForm.ruleDTO.sendType" :label="0" :disabled="activityData.isStart">符合中奖条件就发放</el-radio>
              <el-radio @change="ruleForm.ruleDTO.sendDay= ''" v-model="ruleForm.ruleDTO.sendType" :label="1" :disabled="activityData.isStart">确认收货满
                <el-input
                  v-if="ruleForm.ruleDTO.sendType == 1"
                  v-model="ruleForm.ruleDTO.sendDay" :disabled="activityData.isStart" placeholder=""
                  @input="(e) => (ruleForm.ruleDTO.sendDay = validSe(e))"
                  style="width: 50px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 50px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-radio  @change="ruleForm.ruleDTO.sendDay= ''" v-model="ruleForm.ruleDTO.sendType" :label="2" :disabled="activityData.isStart">活动结束
                <el-input
                  v-if="ruleForm.ruleDTO.sendType == 2"
                  v-model="ruleForm.ruleDTO.sendDay" :disabled="activityData.isStart" placeholder=""
                  @input="(e) => (ruleForm.ruleDTO.sendDay = validSe(e))"
                  style="width: 50px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 50px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-tooltip placement="top-start" effect="dark">
                <div slot="content">
                  1.符合中奖条件就发放:是指下单符合中奖条件，C端用户领取的时候实时发放奖品;<br />
                  2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                  3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                </div>
                <div>
                  发放规则<i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="领取时机:" required v-if="ruleForm.ruleDTO.sendType == 1">
            <el-radio-group v-model="ruleForm.ruleDTO.claimTiming" :disabled="activityData.isStart">
              <el-radio :label="0">先领取后发放</el-radio>
              <el-radio :label="1">
                <span>达到要求后领取立即发放</span>
                <el-tooltip effect="light" placement="top">
                  <template #content>
                    <div>
                      1、先领取后发放：用户达到订单条件后可点击领取，领取后奖品为待发放状态，等到确认收货后N天自动发放；
                    </div>
                    <div>
                      2、达到要求后领取：用户达到订单条件后，需收货后N天才可领取奖品，领取后立即发放给用户
                    </div>
                  </template>
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question grey-color"></i>
                  </el-button>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="更换奖品:" required>
            <div>
              <div><el-radio v-model="ruleForm.ruleDTO.supportRollback" :label="0"
                  :disabled="activityData.isStart">不支持撤回和更换奖品（即仅限领取一次，C端用户确认领取后不支持重新更换奖品）</el-radio></div>
              <div><el-radio v-model="ruleForm.ruleDTO.supportRollback" :label="1"
                  :disabled="activityData.isStart">支持撤回并更换奖品（即奖品发放之前，支持C端用户撤回奖品，重新更换领取新的奖品）</el-radio></div>
            </div>
          </el-form-item>
          <el-form-item label="奖品显示:" required>
              <el-checkbox v-model="ruleForm.ruleDTO.notShowPrizeValue" :disabled="backgroundOpacity">C端不显示奖品价值</el-checkbox>
          </el-form-item>
          <el-form-item label="奖品规则:" required>
            <div>
              <el-radio @change="prizeSettingTypeChange()" v-model="ruleForm.ruleDTO.prizeSettingType" :label="0"
                :disabled="activityData.isStart">统一奖品</el-radio>
              <el-radio @change="prizeSettingTypeChange()" v-model="ruleForm.ruleDTO.prizeSettingType" :label="1"
                :disabled="activityData.isStart">阶梯奖品</el-radio>
              <span v-if="ruleForm.ruleDTO.prizeSettingType == 0" style="color: #F59A23">（注意：整个活动期内每人只可领取其中1个奖品）</span>
              <div class="rule_box">
                <el-form-item label="兑换奖品限制:" required v-if="ruleForm.ruleDTO.prizeSettingType == 1">
                  <el-radio-group v-model="ruleForm.ruleDTO.exchangeType" :disabled="activityData.isStart">
                    <el-radio :label="0">仅可兑换一次</el-radio>
                    <el-radio :label="2">
                      可领取其中一个阶梯的全部奖品
                    </el-radio>
                    <el-radio :label="1">
                      <span>活动期间每人可兑换</span>
                      <el-input 
                        v-model="ruleForm.ruleDTO.exchangeNumber"
                        :disabled="activityData.isStart || ruleForm.ruleDTO.exchangeType == 0"
                        placeholder="请输入"
                        @input="ruleForm.ruleDTO.exchangeNumber = getNumberData(1,$event,0,1,pointActivityPrize.length)"
                        style="width: 120px;margin: 0 6px;"
                      ></el-input>
                      <span style="color: red;">不填默认为不限制次数，每个阶梯仅能领取一个</span>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="统计规则:" required>
                  <el-select style="width: 300px;margin-right: 8px;" v-model="ruleForm.ruleDTO.orderCountType" @change="ruleForm.ruleDTO.measureUnitId == null ? ruleForm.ruleDTO.statisticType = 0 : ''"
                    :disabled="activityData.isStart || ruleForm.ruleDTO.statisticType == 3" placeholder="">
                    <el-option label="单笔订单满" :value="0"></el-option>
                    <el-option label="累计订单满" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <!-- 领奖限制：仅阶梯奖品且统计规则为单笔订单满时显示 -->
                <el-form-item label="领奖限制:" required v-if="ruleForm.ruleDTO.prizeSettingType == 1 && ruleForm.ruleDTO.orderCountType == 0 && ruleForm.ruleDTO.exchangeType == 1">
                  <el-radio-group v-model="ruleForm.ruleDTO.winLimitType" :disabled="activityData.isStart">
                    <el-radio :label="0">单笔订单可领取多个阶梯奖品</el-radio>
                    <el-radio :label="1">单笔订单仅可领取一个奖品，多个阶梯需多笔订单</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="统计类型:" required>
                  <template v-if="ruleForm.ruleDTO.measureUnitId == null">
                    <el-radio-group
                      v-model="ruleForm.ruleDTO.statisticType"
                      :disabled="activityData.isStart"
                      @change="statisticTypeChange()"
                    >
                    <template v-if="ruleForm.ruleDTO.orderCountType == 0">
                      <el-radio :label="0">满额</el-radio>
                      <el-radio :label="1">满件</el-radio>
                      <el-radio :label="2">满额且满件</el-radio>
                    </template>
                    <template v-else-if="ruleForm.ruleDTO.orderCountType == 1">
                      <el-radio :label="0">满额</el-radio>
                      <el-radio :label="1">满件</el-radio>
                      <el-radio :label="3">满笔</el-radio>
                      <el-radio :label="2">满额且满件</el-radio>
                      <el-radio :label="5">满额且满笔</el-radio>
                      <el-radio :label="6">满笔且每笔满额</el-radio>
                    </template>
                  </el-radio-group>
                  </template>
                  <el-radio v-else :label="4" v-model="ruleForm.ruleDTO.statisticType" disabled>
                    满{{ unitName }}
                  </el-radio>
                </el-form-item>
                <el-form-item label="消费门槛:" required v-if="ruleForm.ruleDTO.prizeSettingType == '0'">
                  <template v-if="ruleForm.ruleDTO.statisticType == 0 || ruleForm.ruleDTO.statisticType == 2 || ruleForm.ruleDTO.statisticType == 5">
                    金额≥
                    <el-input v-model="ruleForm.ruleDTO.orderPaymentLimit"
                      @input="(e) => (ruleForm.ruleDTO.orderPaymentLimit = validateInput(e))" :disabled="activityData.isStart"
                      @blur="ruleForm.ruleDTO.orderPaymentLimit ? ruleForm.ruleDTO.orderPaymentLimit = Number(ruleForm.ruleDTO.orderPaymentLimit).toFixed(2) : ''"
                      placeholder="" style="width: 100px;margin: 0 4px;"></el-input>
                    元
                  </template>
                  <template v-if="ruleForm.ruleDTO.statisticType == 1 || ruleForm.ruleDTO.statisticType == 2">
                    {{ruleForm.ruleDTO.statisticType == 1 ? "商品件数≥" : ",且商品件数≥"}}
                    <el-input v-model="ruleForm.ruleDTO.itemLimitCount" placeholder="" :disabled="activityData.isStart"
                      @input="(e) => (ruleForm.ruleDTO.itemLimitCount = validateInputNew(e,0))"
                      style="width: 100px;margin: 0 4px;"></el-input>
                    件
                    <span class="statisticType-tips" v-if="ruleForm.ruleDTO.statisticType == 2">注意：满额和满件两个条件均需配置</span>
                  </template>
                  <template v-if="ruleForm.ruleDTO.statisticType == 3 || ruleForm.ruleDTO.statisticType == 5 || ruleForm.ruleDTO.statisticType == 6">
                    订单笔数≥
                    <el-input v-model="ruleForm.ruleDTO.orderLimitCount" placeholder="" :disabled="activityData.isStart"
                      @input="(e) => (ruleForm.ruleDTO.orderLimitCount = validateInputNew(e,0))"
                      style="width: 100px;margin: 0 4px;"></el-input>
                    笔；
                    <span v-if="ruleForm.ruleDTO.statisticType == 6">
                      且每笔金额≥
                      <el-input v-model="ruleForm.ruleDTO.singleOrderPaymentLimit"
                        @input="(e) => (ruleForm.ruleDTO.singleOrderPaymentLimit = validateInput(e))" :disabled="activityData.isStart"
                        @blur="ruleForm.ruleDTO.singleOrderPaymentLimit ? ruleForm.ruleDTO.singleOrderPaymentLimit = Number(ruleForm.ruleDTO.singleOrderPaymentLimit).toFixed(2) : ''"
                        placeholder="" style="width: 100px;margin: 0 4px;"></el-input>
                      元
                    </span>
                    <span class="statisticType-tips" v-if="ruleForm.ruleDTO.statisticType == 5">注意：满额和满笔两个条件均需配置</span>
                  </template>
                  <template v-if="ruleForm.ruleDTO.statisticType == 4">
                    {{ unitName }}数≥
                    <el-input v-model="ruleForm.ruleDTO.measureUnitLimitCount" placeholder="" :disabled="activityData.isStart"
                      @input="(e) => (ruleForm.ruleDTO.measureUnitLimitCount = getNumberData(1,e,1,0,999999))" style="width: 100px;margin: 0 4px;"></el-input>
                    {{ unitName }}
                  </template>
                </el-form-item>
                <el-form-item label="奖品设置:" v-if="ruleForm.ruleDTO.prizeSettingType == '0'" required>
                  <div v-for="(item, index) in pointActivityPrize" :key="index">
                    <jd-table style="width: 1100px;margin-top: 15px;" :tableData="item.prizeTable">
                      <el-table-column label="奖品类型">
                        <template slot-scope="scope">
                          {{ getPrizeTypeName(scope.row.prizeType) }}
                          <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                          <span v-if="scope.row.prizeType == 2">京豆</span>
                          <span v-if="scope.row.prizeType == 3">实物</span>
                          <span v-if="scope.row.prizeType == 4">店铺积分</span>
                          <span v-if="scope.row.prizeType == 5">京东E卡</span>
                          <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                          <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                          <span v-if="scope.row.prizeType == 8">现金红包</span>
                          <span v-if="scope.row.prizeType == 10">礼品卡</span>
                          <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span>
                          <span v-if="scope.row.prizeType == 13">令牌</span> -->
                        </template>
                      </el-table-column>
                      <el-table-column width="80" prop="price" label="奖品价值">
                      </el-table-column>
                      <el-table-column label="奖品图片(386px*386px)">
                        <template slot-scope="scope">
                          <div style="display:flex;gap: 8px;align-items: center">
                            <img v-if="scope.row.logo != ''" style="border: 1px dashed #d9d9d9" width="40" height="40"
                              :src="scope.row.logo" />
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品名称">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.title"       
                         show-word-limit  :maxlength="15"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品数量">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.totalAmount"
                            @input="(e) => (scope.row.totalAmount = validateInputNew(e))"
                            :disabled="activityData.isStart"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="每日发放限额" width="120">
                        <template slot-scope="scope">
                          <dailyLimitConfig
                            :row="scope.row"
                            :backgroundOpacity="backgroundOpacity"
                            :limitBtnDisabled="backgroundOpacity"
                          ></dailyLimitConfig>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                          <div style="display: flex;">
                              <jd-button type="blueText" style="margin-right: 8px;"
                                @click="selectPrize(scope.$index,item.taskIndex,scope.row)"
                                :disabled="activityData.isStart">选择奖品</jd-button>
                              <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                                :before-upload="beforeUploadPrzieLoge"
                                :on-success="(res)=>{handleUploadPrzieLoge(res,scope.$index,item.taskIndex)}"
                                :disabled="activityData.isStart">
                                <jd-button type="blueText" style="margin-right: 8px;"
                                  :disabled="activityData.isStart">上传图片</jd-button>
                              </el-upload>
                              <jd-button style="margin-right: 8px;" v-if="item.prizeTable.length > 1"
                                @click="itemDel(scope.$index,item.taskIndex)" type="blueText"
                                :disabled="activityData.isStart">删除</jd-button>
                              <jd-button style="margin-right: 8px;" v-if="activityData.isStart"
                                @click="addStock(scope.$index,item.taskIndex,scope.row)" type="blueText"
                                >增加奖品数量</jd-button>
                            </div>
                        </template>
                      </el-table-column>
                    </jd-table>
                    <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                    <jd-button style="margin-top: 8px;" type="blue" @click="addPrizeItem(item.taskIndex)"
                      :disabled="activityData.isStart||item.prizeTable.length == 5">添加奖品({{ item.prizeTable.length
                      }}/5)</jd-button>
                  </div>
                </el-form-item>
                <el-form-item label="阶梯设置:" v-if="ruleForm.ruleDTO.prizeSettingType == '1'" required>
                  <jd-button style="margin-top: 8px;margin-bottom: 10px;" type="blue" @click="addPrizeTask()"
                    :disabled="activityData.isStart||pointActivityPrize.length >= 10">+添加阶梯({{ pointActivityPrize.length
                    }}/10)</jd-button>
                  <div v-for="(item, index) in pointActivityPrize" :key="index" class="taskBox">
                    <div
                      style="width: 100%;background-color: #fafafa;position: absolute;left: 0;top:0;padding: 0 10px;display: flex;justify-content: space-between;font-size: 14px;align-items: center;">
                      <span>阶梯{{ item.taskIndex }}</span><i v-if="!activityData.isStart" @click="delTask(index)" style="cursor: pointer;"
                        class="el-icon-delete"></i></div>
                    <el-form-item label="消费门槛:" required>
                      <template v-if="ruleForm.ruleDTO.statisticType == 0 || ruleForm.ruleDTO.statisticType == 2 || ruleForm.ruleDTO.statisticType == 5">
                        金额≥
                        <el-input v-model="item.orderPaymentLimit"
                          @input="(e) => (item.orderPaymentLimit = validateInput(e))" :disabled="activityData.isStart"
                          @change="(e) => (item.orderPaymentLimit = orderPaymentLimitValidateInput(e,index))"
                          placeholder="" style="width: 100px;margin: 0 4px;"
                          @blur="item.orderPaymentLimit ? item.orderPaymentLimit = Number(item.orderPaymentLimit).toFixed(2) : ''"
                          ></el-input>
                        元
                      </template>
                      <template v-if="ruleForm.ruleDTO.statisticType == 1 || ruleForm.ruleDTO.statisticType == 2">
                        {{ruleForm.ruleDTO.statisticType == 1 ? "商品件数≥" : ",且商品件数≥"}}
                        <el-input v-model="item.itemLimitCount" placeholder=""
                          @input="(e) => (item.itemLimitCount = validateInputNew(e,0))" :disabled="activityData.isStart"
                          @change="(e) => (item.itemLimitCount = itemLimitCountValidateInput(e,index))"
                          style="width: 100px;margin: 0 4px;"></el-input>
                        件
                        <span class="statisticType-tips" v-if="ruleForm.ruleDTO.statisticType == 2">注意：满额和满件两个条件均需配置</span>
                      </template>
                      <template v-if="ruleForm.ruleDTO.statisticType == 3 || ruleForm.ruleDTO.statisticType == 5 || ruleForm.ruleDTO.statisticType == 6">
                        订单笔数≥
                        <el-input v-model="item.orderLimitCount" placeholder=""
                          @input="(e) => (item.orderLimitCount = validateInputNew(e,0))" :disabled="activityData.isStart"
                          @change="(e) => (item.orderLimitCount = itemLimitCountValidateInput(e,index))"
                          style="width: 100px;margin: 0 4px;"></el-input>
                        笔；
                        <span v-if="ruleForm.ruleDTO.statisticType == 6">
                        且每笔金额≥
                        <el-input v-model="item.singleOrderPaymentLimit"
                          @input="(e) => (item.singleOrderPaymentLimit = validateInput(e))" :disabled="activityData.isStart"
                          @blur="item.singleOrderPaymentLimit ? item.singleOrderPaymentLimit = Number(item.singleOrderPaymentLimit).toFixed(2) : ''"
                          placeholder="" style="width: 100px;margin: 0 4px;"></el-input>
                        元
                      </span>
                        <span class="statisticType-tips" v-if="ruleForm.ruleDTO.statisticType == 5">注意：满额和满笔两个条件均需配置</span>
                      </template>
                      <template v-if="ruleForm.ruleDTO.statisticType == 4">
                        {{ unitName }}数≥
                        <el-input v-model="item.measureUnitLimitCount" placeholder="" :disabled="activityData.isStart"
                          @input="(e) => (item.measureUnitLimitCount = getNumberData(1,e,1,0,999999))" style="width: 100px;margin: 0 4px;"></el-input>
                        {{ unitName }}
                      </template>
                    </el-form-item>
                    <div>
                      <jd-table style="width: 1100px;margin-top: 15px;" :tableData="item.prizeTable">
                        <el-table-column label="奖品类型">
                          <template slot-scope="scope">
                            {{ getPrizeTypeName(scope.row.prizeType) }}
                            <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                            <span v-if="scope.row.prizeType == 2">京豆</span>
                            <span v-if="scope.row.prizeType == 3">实物</span>
                            <span v-if="scope.row.prizeType == 4">店铺积分</span>
                            <span v-if="scope.row.prizeType == 5">京东E卡</span>
                            <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                            <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                            <span v-if="scope.row.prizeType == 8">现金红包</span>
                            <span v-if="scope.row.prizeType == 10">礼品卡</span>
                            <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span>
                            <span v-if="scope.row.prizeType == 13">令牌</span> -->
                          </template>
                        </el-table-column>
                        <el-table-column width="80" prop="price" label="奖品价值">
                        </el-table-column>
                        <el-table-column label="奖品图片(386px*386px)">
                          <template slot-scope="scope">
                            <div style="display:flex;gap: 8px;align-items: center">
                              <img v-if="scope.row.logo != ''" style="border: 1px dashed #d9d9d9" width="40" height="40"
                                :src="scope.row.logo" />
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="奖品名称">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.title" show-word-limit  :maxlength="15"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="奖品数量">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.totalAmount"
                              @input="(e) => (scope.row.totalAmount = validateInputNew(e))"
                              :disabled="activityData.isStart"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="每日发放限额" width="120">
                          <template slot-scope="scope">
                            <dailyLimitConfig
                              :row="scope.row"
                              :backgroundOpacity="backgroundOpacity"
                              :limitBtnDisabled="backgroundOpacity"
                            ></dailyLimitConfig>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" width="250">
                          <template slot-scope="scope">
                            <div style="display: flex;">
                              <jd-button type="blueText" style="margin-right: 8px;"
                                @click="selectPrize(scope.$index,item.taskIndex,scope.row)"
                                :disabled="activityData.isStart">选择奖品</jd-button>
                              <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                                :before-upload="beforeUploadPrzieLoge"
                                :on-success="(res)=>{handleUploadPrzieLoge(res,scope.$index,item.taskIndex)}"
                                :disabled="activityData.isStart">
                                <jd-button type="blueText" style="margin-right: 8px;"
                                  :disabled="activityData.isStart">上传图片</jd-button>
                              </el-upload>
                              <jd-button style="margin-right: 8px;" v-if="item.prizeTable.length > 1"
                                @click="itemDel(scope.$index,item.taskIndex)" type="blueText"
                                :disabled="activityData.isStart">删除</jd-button>
                              <jd-button style="margin-right: 8px;" v-if="activityData.isStart"
                                @click="addStock(scope.$index,item.taskIndex,scope.row)" type="blueText"
                                >增加奖品数量</jd-button>
                            </div>
                          </template>
                        </el-table-column>
                      </jd-table>
                       <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                      <jd-button style="margin-top: 8px;" type="blue" @click="addPrizeItem(item.taskIndex)"
                        :disabled="activityData.isStart||item.prizeTable.length == 5">添加奖品({{ item.prizeTable.length
                        }}/5)</jd-button>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <activityPageSettings isShowShopName isShowShopNameByChannel isShowMoreSet downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/满额有礼.psd" designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/满额有礼背景图规范.png" :cusTemplateJSON.sync="cusTemplateJSON" v-model="customerPaperwork" :giftList="giftList" :templateId="templateId" @selectTemplate="selectTemplate" :widthNumber="750" :heightNumber="1740"></activityPageSettings>
          <!-- <jd-title label="活动页设置" type="bold"></jd-title> -->
          <!-- <el-form-item label="活动标题:">
            <el-input placeholder="请输入活动标题" style="width: 425px; margin-left: 8px" show-word-limit
              v-model="customerPaperwork.title" :maxlength="10" ></el-input>
              <el-tooltip class="item" effect="light" content="不填c端则不显示" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
          </el-form-item>
          <el-form-item label="活动说明:">
            <el-input placeholder="请输入活动说明" style="width: 425px; margin-left: 8px" show-word-limit
              v-model="customerPaperwork.desc" :maxlength="25" ></el-input>
              <el-tooltip class="item" effect="light" content="不填c端则不显示" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
          </el-form-item>
          <el-form-item label="标题文字颜色:">
            <div style="display: flex;align-items: center;">
              <el-color-picker v-model="customerPaperwork.titleColor" class="colorPicker">
              </el-color-picker>
              <jd-button type="blueText" style="margin-left: 20px"
                @click="customerPaperwork.titleColor = '#1a1a1a'">重置</jd-button>
            </div>
          </el-form-item> -->
          <exposureList :defaultExposureSwitch.sync="ruleForm.exposureSwitch" :isLimit="isLimit" v-model="itemListFor" :isEdit="isEdit" :multiShopSkuType.sync="ruleForm.ruleDTO.multiShopSkuType" :multiShopGoods="multiShopGoods" :backgroundOpacity="backgroundOpacity" :skuBelongVenderId="ruleForm.ruleDTO.skuBelongVenderId"></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
          <activityRules :valueRow="valueRow" :activityData="activityData" :isForceRemind.sync="isForceRemind" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition" v-model="ruleForm.ruleDescription" @generateRule="generateRule"></activityRules>
          <!-- <jd-title label='分享设置' type="bold"></jd-title>
          <el-form-item label="小程序分享标题:" required label-width="125">
            <el-input type="text" style="width: 425px;margin-left:8px;" show-word-limit v-model="ruleForm.shareTitle"
              :maxlength="28" @input="inp"></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required label-width="125">
            <el-input type="text" style="width: 425px;margin-left:8px;" show-word-limit
              v-model="ruleForm.shareIntroduce" :maxlength="28" @input="inp"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required label-width="130">
            <div class="miniAppPic" style="margin-left:16px;">
              <div class="top">
                <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                  :before-upload="beforeUpload1" :on-success="handleUpload1">
                  <jd-button type="blueText">自定义上传</jd-button>
                </el-upload>
                <jd-button type="blueText" style="margin-left: 8px"
                  @click="picUrlReset1">重置</jd-button>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item> -->
          <!-- <jd-title label='活动规则' type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div style="width: 570px;padding: 8px;">
              <el-input maxlength="2000" type="textarea" class="textarea" style="width: 543px" resize="none"
                v-model="ruleForm.ruleDescription"></el-input>

              <div style="margin-top: 16px">
                <jd-button type="blue" @click="generateRule">生成规则</jd-button>
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->

          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity" style="height: calc(100% - 45px);"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <jd-button v-if="localStepNum == 2" v-show="!itemId" style="margin-right: 8px" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
        }}</jd-button>
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-show="!itemId" v-if="isSave"  type="blue" @click="resetForm" v-preventReClick>保存设置</jd-button>
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit">取消</jd-button>
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor v-if="selectGoodsState" ref="selectGo" :isShow="selectGoodsState" @close="selectGoodsClose" isInteract
      :selectGoods="selectGoodsArr" :moduleType="true" :skuSearch="true" :xianz="true" :disabled="backgroundOpacity">
    </selectGoodsMonitor>

    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" v-if="isSelectProduct" :echoDate="echoDate" :actId="valueRow" :num="1" :actType="46" :actEndTime="ruleForm.endTime"
      :JingdouCount="JingdouCount" @choose-shop="getTheData">
    </selectProduct>

    <!-- 保存设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px">确 定</jd-button>
      </div>
    </el-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods v-if="goodsState" :skuSearch="true" :isShow="goodsState" :moduleType="true" :xianz="true" isInteract
      :selectGoods="selectGoodsSkuList" @close="selectGoodsChange" :venderId="curretnVenderId"></select-goods>
    <!-- 自定义计量单位-选择商品弹窗 -->
    <select-unit-goods v-if="isShowSelectUnitGoods" :skuSearch="true" :venderId="curretnVenderId" :isShow="isShowSelectUnitGoods" :moduleType="true" isInteract
      :selectGoods="selectGoodsSkuList" :measureUnitId="ruleForm.ruleDTO.measureUnitId" @close="selectGoodsChange"></select-unit-goods>
    <!-- 选择人群弹窗 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList"
      @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>

    <!-- 增加库存弹窗 -->
    <addPrizeNum :isShowAddNum="addStockVisible" :prizeData="toAddItem" @confirm="confirmAddStock" @close="addStockVisible=false"/>
    <!-- <el-dialog title="增加奖品库存" :visible.sync="addStockVisible" width="500px">
      <jd-tip color="gley" style="margin:  0 0 12px 0">
        <div>
          进行中的活动仅支持增加库存，不支持减少库存
        </div>
      </jd-tip>
      <el-form label-width="100px">
        <el-form-item label="增加数量:" required>
          <el-input v-model="addAmount" @input="(e) => (addAmount = validateInputNew(e))" type="number" placeholder="请输入增加数量"
            style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="addStockVisible = false">取 消</jd-button>
        <jd-button type="blue" @click="confirmAddStock">确认增加</jd-button>
      </div>
    </el-dialog> -->

  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2.vue";
import selectUnitGoods from "@/views/interactiveMarketing/activity/components/selectUnitGoods.vue";
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import { bigTurntableDraw, modifyBigTurn, getbigTurn, hdTaskTemplateGroup, sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import {
  measureUnitPage,
  unitSkuPage
} from "@/api/measuringUnit.js";
import { fullGiftSave,fullGiftDetail } from "@/api/jhk/fullAmountWidthGifts.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";

import { uploadpic } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import addPrizeNum from "./components/add-prize-num.vue";
import { publicOpen } from "@/api/jhk/public";
import { getShopList } from "@/api/public";
import informationForm from "./components/informationForm.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    SelectGoods,
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    selectUnitGoods,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(3);
    },
    localStepNum(newVal) {
      if (newVal == 0) {
        // this.$nextTick(() => {
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "1" }), queryId);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "2" }), queryId2);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "3" }), queryId3);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "4" }), queryId4);
        // });
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    venderId: {
      handler:function(v) {
        if(v && !this.ids) {
          this.getmeasureUnitPage()
        }
      },
      immediate: true,
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if(newVal) {
    //     this.ruleForm.ruleDTO.orderPaymentType = 0
    //   } else {
    //     this.ruleForm.ruleDTO.orderPaymentType = 1
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.ruleForm.ruleDTO.orderPaymentType = 1
      } 
      // else {
      //   this.ruleForm.ruleDTO.orderPaymentType = 0
      // }
    },
    "ruleForm.ruleDTO.venderIds": {
      handler(newVal, oldVal) {
        if(newVal.length > 1) {
          this.ruleForm.ruleDTO.measureUnitId = null
        }
      },
      deep: true
    }
  },
  data() {
    return {
      newOrderWareList: [],
      isEdit: false,
      isVenderType: false,
      isPop: false,
      // 当前选择店铺id
      curretnVenderId: "",
      // 多存一份来显示店铺名称
      multiShopGoods: [],
      // 新增店铺列表
      shopList: [],
      isForceRemind:false,
      isKeyActivity: 0,
      placementPosition: [],
      cusTemplateJSON:'',

      jdCrm:{
        endTime:'',
      },
      pointActivityPrizeJSON:'',

      joinStartTimeDisabled:false,
      joinEndTimeDisabled:false,

      addAmount:"",
      addStockVisible:false,

      actEndTime: "",
      isShowTip: false,
      // 1.14迭代 指定入会时间
      ruleDto: {
        isCheckOpenCardTime: false,
        openCardStartTime: '',
        openCardEndTime: '',
        plusObject: 0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.ruleDTO.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleForm.ruleDTO.openCardStartTime).valueOf();
        },
      },

      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      isSelectProduct: false,
      mainImagelist: [],
      templateId: "",
      tabActive: 0,
      navItem: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      priceLogo: 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/prizeShow.png',
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=46`,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      valueRow: null,
      echoDate: {},
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          } else {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          } else {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      joinTimePickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 
          || (this.ruleForm.startTime?(time.getTime() < new Date(this.ruleForm.startTime).valueOf() - 8.64e7):false)
          || (this.ruleForm.endTime?(time.getTime() > new Date(this.ruleForm.endTime).valueOf()):false)
          || (this.ruleForm.ruleDTO.joinEndTime?(time.getTime() > new Date(this.ruleForm.ruleDTO.joinEndTime).valueOf()):false)
        },
      },
      joinTimePickerOptionsValueEnd: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 
          || (this.ruleForm.endTime?time.getTime() > new Date(this.ruleForm.endTime).valueOf() - 8.64e7:false)
          || (this.ruleForm.ruleDTO.joinStartTime?time.getTime() < new Date(this.ruleForm.ruleDTO.joinStartTime).valueOf():false)
          || (this.ruleForm.ruleDTO.startTime?time.getTime() < new Date(this.ruleForm.ruleDTO.startTime).valueOf():false)
        },
      },
      orderPickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.ruleDTO.orderEndTime) {
            return time.getTime() > new Date(this.ruleForm.ruleDTO.orderEndTime).valueOf()
          } else {
            return false
          }
        },
      },
      orderPickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (this.ruleForm.ruleDTO.orderStartTime ? time.getTime() < new Date(this.ruleForm.ruleDTO.orderStartTime).valueOf():false) || (this.ruleForm.endTime?time.getTime() > new Date(this.ruleForm.endTime).valueOf():false)
        },
      },
      taskstartpickerOptionsValue: {
        disabledDate: (time) => {
          const endTime = this.taskForm.orderEndTime ? new Date(this.taskForm.orderEndTime).getTime() - 1 * 24 * 60 * 60 * 1000 : null;
          const maxStartTime = endTime ? endTime - 90 * 24 * 60 * 60 * 1000 : null;
          return (
            (endTime && time.getTime() > endTime) ||
            (maxStartTime && time.getTime() < maxStartTime)
          );
        },
      },
      taskpickerOptionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.orderStartTime ? new Date(this.taskForm.orderStartTime).getTime() + 1 * 24 * 60 * 60 * 1000 : null;
          const maxEndTime = startTime ? startTime + 90 * 24 * 60 * 60 * 1000 : null;
          return (
            (startTime && time.getTime() < startTime) ||
            (maxEndTime && time.getTime() > maxEndTime)
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      pointActivityPrize: [
        {
          taskIndex: 1,
          itemLimitCount: '',
          orderPaymentLimit: '',
          orderCountType: '0',
          singleOrderPaymentLimit: "",
          prizeTable: [
            {
              prizeType:'',
              price:'',
              logo:'',
              title:'',
              totalAmount:'',
            }
          ],
        },
      ], // 奖品本地
      // pointActivityPrizeDTOList: [], // 奖品
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        orderCondition: {
          // 指定老客下单时间
          isSelectLastPayTime: false, // 是否指定老客下单时间 false否 true是
          lastPayStartTime: "", // 最后一次付款开始时间
          lastPayEndTime: "", // 最后一次付款结束时间
          // 指定老客购物条件
          isSelectOrder: false, // 是否指定老客购物条件 false否 true是
          orderStartTime: "", // 下单开始时间
          orderEndTime: "", // 下单结束时间
          skuType: 0, //商品类型
          minOrderAmt: "", // 下单金额
          minItemCnt: "", // 商品件数
          skuIds: [], // 指定商品集合
          orderType: 0, // 订单状态
          excludeSkuType: 1, //排除商品规则
        },
        condFollow: false,
        startTime: "",
        endTime: "",
        activityName: "",
        partner: [],
        ruleDTO:{
          multiShopSkuType: 0,
          skuBelongVenderId: "",
          plusObject: 0,
          openCardEndTime: '',
          isCheckOpenCardTime: false,
          openCardStartTime: '',

          joinType: 0, //参与方式
          cusType: 0, //新老客类型
          orderTimeType: 0, // 下单时间类型
          orderPaymentType: 1, //订单金额类型
          filterType: 0, //过滤商品
          filterSkuType: 0, //指定商品规则
          // skuIdList: [], //skuId集合
          // itemList: [], //选中的集合，只做前端回显用
          orderType: 1, //订单状态
          sendType: 0, //发放规则
          sendDay: '', // xx天
          orderTime: '', //报名后指定天数
          supportRollback: 0, //是否支持撤回和更换商品
          prizeSettingType: 0, //0统一奖品 1阶梯奖品
          notShowPrizeValue: false, //C端不显示奖品价值
          showProductConditon: false, //前端：false=不勾选(展示商品)，true=勾选(不展示商品)；后端转换：true/null展示，false不展示
          orderCountType: 1, //订单门槛统计方式 0 单笔满 1累计满
          statisticType: 0, // 统计类型 0满额 1满件 2满额且满件 3满笔
          orderPaymentLimit: '', //订单金额下限
          itemLimitCount: '', //商品件数下限
          orderLimitCount:"", // 订单笔数下限
          signOrderTimeType: 0, //报名后指定类型 0天 1小时 2分钟
          joinEndTime:'', //参与结束时间
          joinStartTime:'', //参与开始时间
          orderStartTime:'', //下单开始时间
          orderEndTime:'', //下单结束时间
          customerPaperwork:'',//活动页设置

          stepList:[], // 阶梯规则
          measureUnitId:null, // 统计单位
          measureUnitLimitCount:"", // 消费门槛-类型4
          venderIds:[],//新增下单店铺
          // 多店铺指定商品
          sellerSkuList: [],
          exchangeNumber: '', // 兑换奖品限制-每个阶梯仅能领取一个
          exchangeType: 0, // 兑换奖品限制-仅可兑换一次
          singleOrderPaymentLimit: "", // 每笔订单金额下限
          winLimitType: 0, // 领奖限制：0/null-单笔订单可领取多个阶梯奖品，1-单笔订单仅可领取一个奖品，多个阶梯需多笔订单
          claimTiming: 0, // 0-先领取后发放，1-达到要求后立即领取并发放
          isSupportManualInputOrder: false, // 是否支持手动输入订单
          mergeOrder: false, // 订单拆单后是否合并
        },

        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        isValidBlackList: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        type: 1,

        goShopSetting: 0, //进店设置
        goShopAppId: '',//小程序appId
        goShopUrl: '',//小程序页面路径
      },
      raffleForm: {
        drawType: 1,
        taskType: 1,
        firstGiveTimes: null,
        everyDayGiveTimes: null,
        point: null,
      },

      conditionValue: [13, 4, 9, 10, 11, 12, 16, 17],
      goodsTypeList: [13, 4, 9, 12],
      goodsLimitList: [13, 4, 12],
      taskForm: {
        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        inviteLimit: null,
        jumpUrl: null,
        selectGoodsSkuList: []
      },
      isTaskEdit: false,
      taskRow: {},
      taskDataList: [],
      sharePic: "",
      bigTurntable: {
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      bigTurntableDrawS: [
      ],
      activityStartTime: null,
      activityEndTime: null,

      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,

      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      itemArr: [],
      goodsState: false,
      goodsLimit: 100,
      selectGoodsSkuList: [],
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,

      prizeIndex:'',
      prizeTaskIndex:'',
      customerPaperwork:{
        title:'满额有礼',
        desc:'数量有限，先到先得',
        titleColor:'#1a1a1a'
      },
      unitList:[], // 计量单位
      isShowSelectUnitGoods: false,
      skuIdListLoading:false,
    };
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 获取任务类型
    getTaskType() {
      return (type) => {
        const obj = this.taskTypeOptions.find(item => item.value == type)
        return obj.label
      }
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const { type, condition, condition2, orderCountType } = item
        let str = condition
        if (type == 13) {
          str = `成功浏览${condition}件商品，赠送1次抽奖机会`
        } else if (type == 4) {
          str = `成功加购${condition}件商品，赠送1次抽奖机会`
        } else if (type == 9) {
          str = `成功分享${condition}次商品，赠送1次抽奖机会`
        } else if (type == 10) {
          str = `成功分享${condition}次店铺，赠送1次抽奖机会`
        } else if (type == 11) {
          str = `成功分享${condition}次活动，赠送1次抽奖机会`
        } else if (type == 12) {
          str = `每成功预约${condition}件商品，赠送1次抽奖机会`
        } else if (type == 16) {
          str = `每${condition}积分可兑换1次机会`
        } else if (type == 17) {
          str = orderCountType == 0 ? `每1个订单赠送1次抽奖机会` : `完成任务赠送1次抽奖机会`
        }
        return str
      }
    },
    // 获取任务次数
    getCount() {
      return (item) => {
        const { type, count, inviteLimit, condition2, activityType, orderCountType } = item
        let str = count
        if (type == 12) {
          str = `活动期间最多完成${condition2}次`
        } else if (type == 8) {
          str = `活动期间最多完成${inviteLimit}次`
        } else if (type == 16) {
          str = `${activityType == 2 ? '活动期间' : '活动期间每日'}最多完成${condition2}次`
        } else if (type == 17) {
          str = `活动期间最多完成${orderCountType == 0 ? condition2 : '1'}次`
        }
        return str
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    // 自定义单位名称
    unitName() {
      if(this.unitList.length > 0) {
        const item = this.unitList.find(v=> v.id == this.ruleForm.ruleDTO.measureUnitId)
        if(item) {
          return item.name
        } else {
          return ""
        }
      } else {
        return ""
      }
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    getTitle() {
      return (venderId)=>{
        const item = this.shopList.find(v=> v.venderId == venderId)
        if(item) {
          return item.shopTitle
        } else {
          return ""
        }
      }
    }
  },
  created() {
    if(this.venderType){
      this.ruleForm.ruleDTO.orderPaymentType = 1
    }
    this.ruleForm.ruleDTO.venderIds = [this.venderId]
    this.ruleForm.ruleDTO.sellerSkuList = [{
      venderId: this.venderId,
      skuIds: [],
      itemList: [],
    }]
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
  },
  mounted() {
    this.getLevel();
    this.initDataSequence()
  },

  methods: {
    statisticTypeChange() {
      if(this.ruleForm.ruleDTO.prizeSettingTyp == 0) {
        this.ruleForm.ruleDTO.orderPaymentLimit = '';
        this.ruleForm.ruleDTO.itemLimitCount = '';
        this.ruleForm.ruleDTO.orderLimitCount = '';
        this.ruleForm.ruleDTO.singleOrderPaymentLimit = '';
        this.ruleForm.ruleDTO.measureUnitLimitCount = '';
      } else {
        this.pointActivityPrize.forEach((item)=>{
          item.orderPaymentLimit = "";
          item.itemLimitCount = "";
          item.orderLimitCount = "";
          item.singleOrderPaymentLimit = "";
          item.measureUnitLimitCount = "";
        })
      }
    },
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    goToMeasureUnit(){
      let routeUrl = this.$router.resolve({
        path: "/interactiveMarketing/interactiveMeasure_Unit"
      });
      window.open(routeUrl.href, "_blank");
    },
    // 切换商品要求重置商品
    handleFilterType(val) {
      this.selectGoodsSkuList = []
      this.ruleForm.ruleDTO.sellerSkuList.forEach((item)=>{
        item.skuIds = [];
        item.itemList = []
      })
      // 切换为全部商品时，重置为默认false（不勾选=展示商品）
      if(val == 0) {
        this.ruleForm.ruleDTO.showProductConditon = false;
      }
    },
    async initDataSequence() {
      try {
          // 等待getShopAllList接口完成
          await this.getShopAllList();
          // 后续接口按顺序执行
          this.getDetail();
          this.hdTaskTemplateGroup();
          this.publicOpen();
        } catch (error) {
      }
    },
    getShopAllList() {
      return getShopList().then(res=>{
        if(res.code == 1){
          const resData = res.data.filter(item=> item)
          if (resData && resData.length){
            this.shopList = resData;
          } else {
            this.shopList = [
              {
                shopTitle: this.$store.getters.loginUserInfo.shopTitle,
                venderId: this.$store.getters.loginUserInfo.venderId,
                venderType: this.venderType,
                defaultFlag: true,
              },
            ];
          }
          this.getShopStatus([this.venderId])
        } else {
          this.shopList = [{
            shopTitle: this.$store.getters.loginUserInfo.shopTitle,
            venderId: this.venderId,
            venderType: this.venderType,
            defaultFlag: true
          }]
        }
      }).catch(()=>{
        this.shopList = [{
          shopTitle: this.$store.getters.loginUserInfo.shopTitle,
          venderId: this.venderId,
          venderType: this.venderType,
          defaultFlag: true
        }]
      })
    },
    getShopStatus(shopList) {
      this.multiShopGoods = this.shopList.filter((item)=>{
        return shopList.includes(item.venderId)
      })
      this.isVenderType = this.multiShopGoods.some((item)=>item.venderType);
      this.isPop = this.multiShopGoods.every((item)=>!item.venderType);
    },
    checkShopChange(shopList) {
      this.getShopStatus(shopList);
      // 1. 保存当前已选择的skuIds映射
      const existingSkuMap = new Map();
      this.ruleForm.ruleDTO.sellerSkuList.forEach(item => {
        existingSkuMap.set(item.venderId+'', item.skuIds);
      });
      if(shopList.length > 1) {
        this.ruleForm.ruleDTO.statisticType = 0
        this.customerPaperwork.title = "满额有礼"
        this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
      }
      // 2. 清空现有列表但保留映射关系
      this.ruleForm.ruleDTO.sellerSkuList = [];
      // 3. 重新添加选中店铺，恢复原有skuIds
      shopList.forEach(venderId => {
        // 查找店铺信息
        const shopInfo = this.shopList.find(shop => shop.venderId == venderId);
        if (shopInfo) {
          this.ruleForm.ruleDTO.sellerSkuList.push({
            venderId: venderId,
            // 恢复已选择的skuIds，新店铺则初始化为空数组
            skuIds: existingSkuMap.get(venderId+'') || [],
            itemList: []
          });
        }
      });
    },
    selectTemplate(index,id){
      this.templateId = id
      this.templateJson.templateUItype = index;
    },
    unitChange(e){
      this.selectGoodsSkuList = []
      if(e == null){
        this.ruleForm.ruleDTO.filterType = 0
        this.ruleForm.ruleDTO.statisticType = 0
        this.customerPaperwork.title = "满额有礼"
        this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
      }else{
        this.ruleForm.ruleDTO.filterType = 1
        this.ruleForm.ruleDTO.statisticType = 4
        this.ruleForm.ruleDTO.measureUnitLimitCount = "";
        this.customerPaperwork.title = `满${this.unitName}有礼`
        this.ruleForm.shareTitle = `我分享了一个满${this.unitName}有礼活动给你，快来看看吧！`
      }
    },
    // 获取自定义单位
    getmeasureUnitPage(){
      let data = {
        venderId:this.venderId,
        size:9999,
        current:1,
      }
      measureUnitPage(data).then(res=>{
        if(res.code == 1){
          const list = res.data.records || []
          this.unitList = list.filter(v=> v.status == 1 || v.id == this.ruleForm.ruleDTO.measureUnitId)
        }
      })
    },
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          this.jdCrm.endTime = res.message;
        }
      });
    },
    joinTimeDisabled(){
      let nowTime = Date.now()
      let startTime = new Date(this.ruleForm.ruleDTO.joinStartTime).valueOf()
      let endTime = new Date(this.ruleForm.ruleDTO.joinEndTime).valueOf()
      if(this.activityData.isStart){
        if(startTime < nowTime){
          console.log("当前时间大于开始时间，不能改")
          this.joinStartTimeDisabled = true
        }
      }
    },
    joinTimeEndDisabled(){
      let nowTime = Date.now()
      let startTime = new Date(this.ruleForm.ruleDTO.joinStartTime).valueOf()
      let endTime = new Date(this.ruleForm.ruleDTO.joinEndTime).valueOf()
      if(this.activityData.isStart){
        if(endTime<nowTime){
          this.joinEndTimeDisabled = true
        }
      }
    },
    addStock(index,task,row){
      console.log('task',task)
      console.log("row",row)
      this.toAddItem = {
        ...row,
        num: row.totalAmount
      };
      this.addStockVisible = true
      this.prizeIndex = index
      this.prizeTaskIndex = task
    },
    confirmAddStock(num){
      this.pointActivityPrize.forEach(item=>{
        if(item.taskIndex == this.prizeTaskIndex){
          item.prizeTable[this.prizeIndex].totalAmount = Number(num)
        }
      })
      this.addStockVisible = false
    },
    orderSelectGoods(venderId){
      if(this.ruleForm.ruleDTO.filterType!=0) {
        this.curretnVenderId = venderId;
      }
      if(this.ruleForm.ruleDTO.sellerSkuList.length>0) {
        this.selectGoodsSkuList = this.ruleForm.ruleDTO.sellerSkuList.filter(item=>item.venderId == venderId)[0].itemList;
      }
      if(this.ruleForm.ruleDTO.statisticType == 4) {
        this.isShowSelectUnitGoods = true
      } else {
        this.goodsState = true
      }
    },
    selectPrize(index,taskIndex,row){
      this.prizeIndex = index
      this.prizeTaskIndex = taskIndex
      this.JingdouCount.prizeCount = row.totalAmount;
      this.isSelectProduct = true
      this.echoDate = row;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      })
    },
    handleUploadPrzieLoge(res,index,taskIndex) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.pointActivityPrize.forEach(item=>{
            if(item.taskIndex == taskIndex){
              item.prizeTable[index].logo = res.data
            }
          })
          this.$forceUpdate()
        }
      }
    },
    prizeSettingTypeChange(){
      this.pointActivityPrize = []
      if(this.ruleForm.ruleDTO.prizeSettingType == '0'){
        this.addPrizeTask()
      }else if(this.ruleForm.ruleDTO.prizeSettingType == '1'){
        this.addPrizeTask()
        this.addPrizeTask()
        // 切换到阶梯奖品时，领奖限制默认选中"单笔订单可领取多个阶梯奖品"
        this.ruleForm.ruleDTO.winLimitType = 0
      }
    },
    delTask(index){
      if(this.pointActivityPrize.length<=2){
        return this.$message.warning('至少保留两个阶梯')
      }
      this.pointActivityPrize.splice(index, 1);
      this.pointActivityPrize.forEach((item,index)=>{
        item.taskIndex = index+1
      })
    },
    creatPointActivityPrizeDTO(){
      let pointActivityPrizeDTO = {
        taskIndex: 1,
        itemLimitCount: '',
        orderLimitCount: "",
        measureUnitLimitCount:"",
        orderPaymentLimit: '',
        orderCountType: '0',
        singleOrderPaymentLimit: "",
        prizeTable: [
          {
            prizeType:'',
            price:'',
            logo:'',
            title:'',
            totalAmount:'',
          }
        ],
    } 
    return pointActivityPrizeDTO
    },
    addPrizeTask(){
      let addData = this.creatPointActivityPrizeDTO()
      addData.taskIndex = this.pointActivityPrize.length + 1
      this.pointActivityPrize.push(addData)
    },
    itemDel(index,taskIndex) {
      this.pointActivityPrize.forEach(item=>{
        if(item.taskIndex == taskIndex){
          item.prizeTable.splice(index, 1);
        }
      })
    },
    prizeItem(){
      let item = {
        prizeType:'',
        price:'',
        logo:'',
        title:'',
        totalAmount:'',
      }
      return item
    },
    addPrizeItem(taskIndex){
      this.pointActivityPrize.forEach(item=>{
        if(item.taskIndex == taskIndex){
          item.prizeTable.push(this.prizeItem())
        }
      })
    },
    validSe(data, type = 0) {
      let filtered = data.replace(/[^\d]/g, "");
      if (type = 0) {
        if (Number(filtered) < 1) {
          filtered = "";
        }
      }
      if(Number(filtered) >= 30){
          filtered = "30";
      }
      return filtered
    },
    // 点击下单时间显示提示
    orderFocus() {
      if (this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = '';
      this.ruleForm.goShopUrl = '';
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map(item => {
        return { id: item }
      })
      this.selectPeopleShow = true
      this.actMember = "3"
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map(item => item.id)
      this.selectPeopleShow = false
    },
    inp(val) {
      this.$forceUpdate()
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)) {
          row.totalAmount = ""
          if (row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
          if (row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
          if (row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
          if (row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
          if (row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    beforeUploadPrzieLoge(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 386 && image.height == 386)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      // if (!isLt3M) {
      //   this.$message.info("上传图片大小不能超过 1MB");
      //   return false
      // }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          this.$forceUpdate()
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic
      this.$forceUpdate()
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite()
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
        // hdTaskType: 16
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.getPolite()
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
        // hdTaskType: 16,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      if(!this.templateId){
        this.templateId = this.giftList[0].id
        // this.localStepNum = 1;
        this.templateJson.templateUItype = 0;
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate()
    },

    nextStepKai(index, templateId = 0) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = index;
      if (templateId) {
        this.templateId = templateId
      }
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => { });
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url =  "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=" 
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `${url}${this.giftList[index].imageUrl}`
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (row.quantityTotal && row.price && row.totalAmount && row.prizeType == 2) {
          let numTotal = this.$jingdouTotal({ ...row, prizeCount: row.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimit(row, min) {
      let newVal = (row.dailyLimit + "").replace(/[^\d]/g, '')
      if (newVal) {
        if (newVal < min) {
          return ""
        } else {
          if (Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return ""
          } else {
            return Number(row.dailyLimit)
          }
        }
      }
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() { },
    getRuleText(row) {
      const staticTypes = {
          0: "元",
          1: "件",
          2: '元',
          3: "笔",
          5: "元",
          6: "笔"
         }
         const listType = [0,2,5]
         let textAmt = ""
        let secondText1 = ""
        if(this.ruleForm.ruleDTO.statisticType==1) {
          textAmt += "商品件数满"
        }
         if(listType.includes(this.ruleForm.ruleDTO.statisticType)) {
          textAmt += '满'+row.orderPaymentLimit
          if(this.ruleForm.ruleDTO.statisticType==2) {
            secondText1= "且商品件数满" + row.itemLimitCount + "件"
          }
          if(this.ruleForm.ruleDTO.statisticType==5) {
            secondText1 = "且订单笔数满" + row.orderLimitCount +"笔"
          }
         } else if(this.ruleForm.ruleDTO.statisticType==3||this.ruleForm.ruleDTO.statisticType==6) {
          textAmt += "满"+ row.orderLimitCount 
          if(this.ruleForm.ruleDTO.statisticType==6) {
            secondText1 = "且每笔订单满" + row.singleOrderPaymentLimit +"元"
          }
         } else if(this.ruleForm.ruleDTO.statisticType==1) {
          textAmt += "满" + row.itemLimitCount
         }
         return `${textAmt}${staticTypes[this.ruleForm.ruleDTO.statisticType]}${secondText1}`
    },
    //生成规则
    generateRule() {
      let text1 = "参与方式：",
        text2 = "活动奖品：",
        text3 = "奖品发放规则：",
        text4 = "有效订单不包含售中退款/售后退款，如成功参与活动的用户对商品订单进行售后行为，导致实际支付金额不足活动门槛金额的，或者因客户原因导致的恶意退款，视为用户不符合中奖资格，商家有权取消该用户获取奖品的资格。",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "实物奖品需填写收货地址后进行发货；若收货地址填写截止时间前未填写收货信息视为自动放弃中奖资格，奖品失效处理，且奖品不予补发！",
        text9 = "礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；",
        shopText = "",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleForm.ruleDTO,this.actMember,true,true,true)
        if(this.ruleForm.ruleDTO.joinType==0) {
          text1 += "报名时间范围内，进入活动手动报名参与；"
        } else {
          text1 += "有效时间范围内，下单满足条件进入活动页后自动报名参与；"
        }
        let ruleTypes = {
            0: "单笔订单",
            1: "累计订单",
          }
  

        
        if(this.ruleForm.ruleDTO.prizeSettingType==0) {
          text2 += `统一奖品（${ruleTypes[this.ruleForm.ruleDTO.orderCountType]}${this.getRuleText(this.ruleForm.ruleDTO)}）\n`
          let prizeText = this.pointActivityPrize[0].prizeTable.map((item,index)=>{
            let text = `（${index+1}）奖品${index+1}：${item.title}，共${item.totalAmount}份${item.prizeType==3 ? ('，单份奖品价值'+item.price+'元') : ''}；`
            if(index<this.pointActivityPrize[0].prizeTable.length-1) {
              text += `\n`
            }
            return text
          })
          text2+= prizeText.join("")
        } else {
          text2 += "阶梯奖品\n"
          let orderArr = ['一','二','三','四','五'];
          let stepList = this.pointActivityPrize.map((item,index)=>{
            let text = `（${index+1}）阶梯${orderArr[index]}（${ruleTypes[this.ruleForm.ruleDTO.orderCountType]}${this.getRuleText(item)}，有机会得该阶梯奖品）\n`  
            item.prizeTable.forEach((item2,index2)=>{
              text += `奖品${index2+1}：${item2.title}，共${item2.totalAmount}份${item2.prizeType==3 ? ('，单份奖品价值'+item2.price+'元') : ''}；`
              if(index2<item.prizeTable.length-1) {
                text += `\n`
              }
            })
            if(index<this.pointActivityPrize.length-1) {
              text += `\n`
            }
            return text
          })
          text2+= stepList.join("")
        }
        if(this.ruleForm.ruleDTO.sendType==0) {
          text3 += "符合中奖条件可领取（虚拟奖品领取后自动发放，实物奖品由商家手动发放）"
        } else if(this.ruleForm.ruleDTO.sendType==1) {
          text3 += `收货后满${this.ruleForm.ruleDTO.sendDay}天发放（虚拟奖品领取后自动发放，实物奖品由商家手动发放）；`
        } else {
          text3 += `活动结束${this.ruleForm.ruleDTO.sendDay}天后发放（虚拟奖品领取后自动发放，实物奖品由商家手动发放）；`
        }
      if(this.multiShopGoods.length>1) {
        shopText = this.multiShopGoods.map((item)=>item.shopTitle).join(",")
      } else if(this.multiShopGoods.some(item=>item.venderId==this.venderId)){
        shopText = '店铺'
      }
      text5 = '参与规则：'
      if(this.ruleForm.ruleDTO.orderTimeType=='0'){
        text5 = text5 + `在${this.ruleForm.ruleDTO.orderStartTime}~${this.ruleForm.ruleDTO.orderEndTime}期间下单付款${shopText}`
      }
      if(this.ruleForm.ruleDTO.orderTimeType=='1'){
        text5 = text5 + `在报名后${this.ruleForm.ruleDTO.orderTime}${this.ruleForm.ruleDTO.signOrderTimeType == 0?'天':this.ruleForm.ruleDTO.signOrderTimeType == 1?'小时':this.ruleForm.ruleDTO.signOrderTimeType == 2?'分钟':''}内下单付款店铺`
      }
      if(this.ruleForm.ruleDTO.measureUnitId != null) {
        text5 = text5 + "指定计量单位商品（指定商品见活动页）"
      } else {
        text5 = text5 + (this.ruleForm.ruleDTO.filterType == 0?'任意商品,':this.ruleForm.ruleDTO.filterType == 1?'指定商品（指定商品见活动页），':this.ruleForm.ruleDTO.filterType == 3?'除指定商品外的任意商品（排除商品见活动页），':'')
      }
      if(this.ruleForm.ruleDTO.prizeSettingType=='0'){
        if(this.ruleForm.ruleDTO.orderPaymentLimit && (this.ruleForm.ruleDTO.statisticType == 0 || this.ruleForm.ruleDTO.statisticType == 2)){
          text5 = text5 +`且${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单金额：大于等于${this.ruleForm.ruleDTO.orderPaymentLimit}元;`
        }
        if(this.ruleForm.ruleDTO.itemLimitCount && (this.ruleForm.ruleDTO.statisticType == 1 || this.ruleForm.ruleDTO.statisticType == 2)){
          text5 = text5 +`且${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}商品件数：大于等于${this.ruleForm.ruleDTO.itemLimitCount}件;`
        }
        if(this.ruleForm.ruleDTO.orderLimitCount && this.ruleForm.ruleDTO.statisticType == 3){
          text5 = text5 +`且${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单笔数：大于等于${this.ruleForm.ruleDTO.orderLimitCount}笔;`
        }
        if(this.ruleForm.ruleDTO.statisticType == 4){
          text5 = text5 +`且${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}商品${this.unitName}数：大于等于${this.ruleForm.ruleDTO.measureUnitLimitCount || ""}${this.unitName};`
        }
        if(this.ruleForm.ruleDTO.statisticType == 5){
          text5 = text5 +`且${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单金额：大于等于${this.ruleForm.ruleDTO.orderPaymentLimit}元：订单笔数大于等于${this.ruleForm.ruleDTO.orderLimitCount || ""}；`
        }
        if(this.ruleForm.ruleDTO.statisticType == 6) {
          text5 = text5 +`且${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单笔数：大于等于${this.ruleForm.ruleDTO.orderLimitCount}笔：且每笔订单金额大于等于${this.ruleForm.ruleDTO.singleOrderPaymentLimit || ""}；`
        }
      } else if(this.ruleForm.ruleDTO.prizeSettingType=='1') {
        this.pointActivityPrize.forEach((item,index)=>{
          let stepText = `阶梯${index + 1}：`
          if(item.orderPaymentLimit && (this.ruleForm.ruleDTO.statisticType == 0 || this.ruleForm.ruleDTO.statisticType == 2)){
            stepText = stepText +`${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单金额：大于等于${item.orderPaymentLimit}元;`
          }
          if(item.itemLimitCount && (this.ruleForm.ruleDTO.statisticType == 1 || this.ruleForm.ruleDTO.statisticType == 2)){
            stepText = stepText +`${this.ruleForm.ruleDTO.statisticType == 2 ? "且" : this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}商品件数：大于等于${item.itemLimitCount}件;`
          }
          if(item.orderLimitCount && this.ruleForm.ruleDTO.statisticType == 3){
            stepText = stepText +`${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单笔数：大于等于${item.orderLimitCount}笔;`
          }
          if(this.ruleForm.ruleDTO.statisticType == 4) {
            stepText = stepText +`${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}商品${this.unitName}数：大于等于${item.measureUnitLimitCount || ""}${this.unitName};`
          }
          if(this.ruleForm.ruleDTO.statisticType == 5) {
            stepText = stepText +`${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单金额：大于等于${item.orderPaymentLimit}元：订单笔数大于等于${item.orderLimitCount || ""}；`
          }
          if(this.ruleForm.ruleDTO.statisticType == 6) {
            stepText = stepText +`${this.ruleForm.ruleDTO.orderCountType == 0 ? '单笔' : '累计'}订单笔数：大于等于${item.orderLimitCount}笔：且每笔订单金额大于等于${item.singleOrderPaymentLimit || ""}；`
          }
          text5 += stepText;
        })
      }
      if(this.ruleForm.ruleDTO.measureUnitId != null) {
        text5 = text5 + `(统计时间段内购买指定计量单位商品的整单商品${this.unitName}数)${this.ruleForm.ruleDTO.orderType == '1' ? '且订单状态为已完成;' : '且订单状态为已付款;'}`
      } else if(this.ruleForm.ruleDTO.orderType == '1'){
        text5 = text5+(this.ruleForm.ruleDTO.filterType == 0?'':this.ruleForm.ruleDTO.filterType == 1?"(统计时间段内购买指定商品的整单商品件数及金额)":"(统计时间段内购买排除商品之外的商品件数及金额,含排除商品的订单整单排除)")+`且订单状态为已完成;`
      } else if(this.ruleForm.ruleDTO.orderType == '0'){
        text5 = text5+(this.ruleForm.ruleDTO.filterType == 0?'':this.ruleForm.ruleDTO.filterType == 1?"(统计时间段内购买指定商品的整单商品件数及金额)":"(统计时间段内购买排除商品之外的商品件数及金额,含排除商品的订单整单排除)")+`且订单状态为已付款;`
      }
      text6 = '报名时间：'+ (this.ruleForm.ruleDTO.joinType == '1'?'活动期间下单且符合活动对象时自动参与；':this.ruleForm.ruleDTO.joinType=='0'?`${this.ruleForm.ruleDTO.joinStartTime}~${this.ruleForm.ruleDTO.joinEndTime}`:'')
      text7 = `报名参与购物活动后，下单达到条件并领取奖品，`
      if(this.ruleForm.ruleDTO.sendType == '0'){
        text7 = text7 + `虚拟奖品自动发放，实物奖品由商家手动发放；`
      }
      if(this.ruleForm.ruleDTO.sendType == '2'){
        text7 = text7 +  `活动结束${this.ruleForm.ruleDTO.sendDay}天后，虚拟奖品自动发放，实物奖品由商家手动发放；`
      }
      if(this.ruleForm.ruleDTO.sendType == '1'){
        text7 = text7 + `用户完成确认收货满${this.ruleForm.ruleDTO.sendDay}天，虚拟奖品自动发放，实物奖品由商家手动发放；`
      }
      let Arr1 = [
        firstText,
        [secondText,text1,text5,text6,text7],
        [thirdText,text2,text3,text4,text8,text9],
        [fourthText,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText;
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      this.pointActivityPrize.forEach(item => {
        if (item.taskIndex == this.prizeTaskIndex) {
          // item.prizeTable[this.prizeIndex] = 
          if (prizeType == 1) {
            item.prizeTable[this.prizeIndex].couponType = data.couponType;
          }
          if (data.giftType) {
            item.prizeTable[this.prizeIndex].giftType = Number(data.giftType);
          }
          item.prizeTable[this.prizeIndex].price = Number(data.discount);
          item.prizeTable[this.prizeIndex].assetsId = Number(data.couponId || data.skuId);
          this.$set(item.prizeTable[this.prizeIndex], 'logo', data.logo? data.logo:this.priceLogo);
          item.prizeTable[this.prizeIndex].prizeType = prizeType;
          if (prizeType == 4) {
            item.prizeTable[this.prizeIndex].title = data.discount + "店铺积分";
          } else {
            item.prizeTable[this.prizeIndex].title = data.name;
          }
          if (data.singleAmount) {
            item.prizeTable[this.prizeIndex].singleAmount = data.singleAmount;
          }
          if (prizeType == 2) {
            item.prizeTable[this.prizeIndex].quantityTotal = data.quantityTotal;
          }
          if (prizeType == 3) {
            item.prizeTable[this.prizeIndex].addressFillEndTime = data.addressFillEndTime
            item.prizeTable[this.prizeIndex].predictSendTime = data.predictSendTime
            item.prizeTable[this.prizeIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
            item.prizeTable[this.prizeIndex].shouldCollectExtraData = data.shouldCollectExtraData;
            item.prizeTable[this.prizeIndex].extraQuestion = data.extraQuestion;
            item.prizeTable[this.prizeIndex].addressFillLimit = data.addressFillLimit
            item.prizeTable[this.prizeIndex].commitAddressLimit = data.commitAddressLimit
            if (!data.isGoodManage) {
              item.prizeTable[this.prizeIndex].skuId = data.skuId;
              delete item.prizeTable[this.prizeIndex].isGoodManage
            } else {
              item.prizeTable[this.prizeIndex].isGoodManage = data.isGoodManage;
            }
          }
          // 实物随单发
          if (prizeType == 14 || prizeType == 1) {
            this.getPhysicalShipped(item.prizeTable[this.prizeIndex],prizeType,data);
          }
          // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
          if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
            item.prizeTable[this.prizeIndex].budgetRemain = data.budgetRemain;
          }
          if (prizeType == 3 && data.isGoodManage) {
            item.prizeTable[this.tableIndex].budgetRemain = data.budgetRemain;
          }
        }
      })
      this.isSelectProduct = false
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    isMonotonicIncreasing(arr) {
      return arr.every((value, index, array) => {
        return index === 0 || parseFloat(value) > parseFloat(array[index - 1]);
      });
    },
    // 下一步
    resetForm() {
      if (this.ruleForm.ruleDTO.joinType == 0 && (!this.ruleForm.ruleDTO.joinStartTime||!this.ruleForm.ruleDTO.joinEndTime)) {
        this.$message.warning("请完善报名时间范围");
        return;
      }
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if(this.ruleForm.ruleDTO.joinType == 0){
        let startTime = new Date(this.ruleForm.startTime).valueOf()
        let endTime = new Date(this.ruleForm.endTime).valueOf()
        let joinStartTime = new Date(this.ruleForm.ruleDTO.joinStartTime).valueOf()
        let joinEndTime = new Date(this.ruleForm.ruleDTO.joinEndTime).valueOf()
        if(!(startTime<=joinStartTime<joinEndTime<endTime)){
          this.$message.warning("报名时间需要大于报名开始时间小于报名结束时间！");
          return;
        }
      }
      //活动对象限制
      if (this.actMember == 2 && (!this.ruleForm.partner || this.ruleForm.partner.length == 0)) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      // if (this.actMember == '2') {
      //   if (this.ruleForm.ruleDTO.isCheckOpenCardTime && (!this.ruleForm.ruleDTO.openCardStartTime || !this.ruleForm.ruleDTO.openCardEndTime)) {
      //     return this.$message.warning("请选择入会时间");
      //   }
      // }
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          (!this.ruleForm.openCardBeforeDay)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleForm.ruleDTO.openCardStartTime || !this.ruleForm.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      // 最后一次订单完成时间
      if (this.ruleForm.lastOrderCompleteTimeType == 1 && (!this.ruleForm.lastOrderCompleteEndDay && !this.ruleForm.lastOrderCompleteStartDay)) {
        return this.$message.warning("最后一次订单完成时间");
      }

      if (this.ruleForm.lastOrderCompleteTimeType == 2 && !this.ruleForm.lastOrderCompleteStartTime && !this.ruleForm.lastOrderCompleteEndTime) {
        return this.$message.warning("最后一次订单完成时间");
      }

      if (this.ruleForm.ruleDTO.venderIds.length == 0){
        return this.$message.warning("请选择下单店铺");
      }
        // 下单条件校验
        if(this.ruleForm.ruleDTO.cusType == 3){
        // 最后付款时间
        if (this.ruleForm.orderCondition.isSelectLastPayTime) {
          if (
            !this.ruleForm.orderCondition.lastPayStartTime ||
            !this.ruleForm.orderCondition.lastPayEndTime
          ) {
            this.$message.warning("请选择最后一次付款时间");
            return;
          }
          if (
            new Date(this.ruleForm.orderCondition.lastPayStartTime).getTime() >
            new Date(this.ruleForm.orderCondition.lastPayEndTime).getTime()
          ) {
            this.$message.warning("最后一次付款开始时间不能大于最后一次付款结束时间");
            return;
          }
          if (
            new Date(this.ruleForm.orderCondition.lastPayStartTime).getTime() >
            new Date(this.ruleForm.endTime).getTime()
          ) {
            this.$message.warning("最后一次付款结束时间不能大于活动结束时间");
            return;
          }
        }
        // 购物条件
        if (this.ruleForm.orderCondition.isSelectOrder) {
          // 下单时间
          if (
            !this.ruleForm.orderCondition.orderStartTime ||
            !this.ruleForm.orderCondition.orderEndTime
          ) {
            this.$message.warning("请补充指定购物条件下单时间");
            return;
          }
          if (
            new Date(this.ruleForm.orderCondition.orderStartTime).getTime() >
            new Date(this.ruleForm.orderCondition.orderEndTime).getTime()
          ) {
            this.$message.warning("指定购物条件下单时间开始时间不能大于指定购物条件下单结束时间");
            return;
          }
          if (
            new Date(this.ruleForm.orderCondition.orderEndTime).getTime() >
            new Date(this.ruleForm.endTime).getTime()
          ) {
            this.$message.warning(
              "指定购物条件下单结束时间不能大于活动结束时间"
            );
            return;
          }
          // 商品要求
          if (this.ruleForm.orderCondition.skuType == 1 && !this.newOrderWareList.length) {
            this.$message.warning("请勾选指定商品~");
            return;
          }
          if (this.ruleForm.orderCondition.skuType == 2 && !this.newOrderWareList.length) {
            this.$message.warning("请勾选排除商品~");
            return;
          }
          if (!this.ruleForm.orderCondition.minOrderAmt) {
            this.$message.warning("请输入订单金额");
            return;
          }
        }
      }

      if(this.ruleForm.ruleDTO.orderTimeType=='0'&&(!this.ruleForm.ruleDTO.orderStartTime||!this.ruleForm.ruleDTO.orderEndTime)){
        return this.$message.warning("请完善下单时间");
      }
      
      if(this.ruleForm.ruleDTO.orderTimeType == 0){
        let endTime = new Date(this.ruleForm.endTime).valueOf()
        let orderEndTime = new Date(this.ruleForm.ruleDTO.orderEndTime).valueOf()
        if(orderEndTime>endTime){
          this.$message.warning("下单结束时间需要小于活动结束时间");
          return;
        }
  }

      if(this.ruleForm.ruleDTO.orderTimeType=='1'&&!this.ruleForm.ruleDTO.orderTime){
        return this.$message.warning("请完善下单时间");
      }
      if(this.ruleForm.ruleDTO.filterType!='0'&&this.ruleForm.ruleDTO.venderIds.length==1&&this.ruleForm.ruleDTO.sellerSkuList[0].skuIds.length==0){
        if(this.activityData.isStart && this.ruleForm.ruleDTO.statisticType == 4) {
          return this.$message.warning("关联商品不存在~");
        }
        return this.$message.warning("请选择商品");
      }
      // 指定商品
      if(this.ruleForm.ruleDTO.filterType!=0&&this.ruleForm.ruleDTO.sellerSkuList.length>1){
        let flag = false
        this.ruleForm.ruleDTO.sellerSkuList.some((item)=>{
          if(item.skuIds.length==0) {
            flag = true
          }
        })
        if(flag&&this.ruleForm.ruleDTO.filterType==1) {
          return this.$message.warning("请选择指定商品");
        } else if(flag&&this.ruleForm.ruleDTO.filterType==2) {
          return this.$message.warning("请选择排除品");
        }
      }
      if(this.ruleForm.ruleDTO.sendType!='0'&&!this.ruleForm.ruleDTO.sendDay){
        return this.$message.warning("请完善发放规则");
      }
      if(this.activityData.isStart == false) {
        const unitItem = this.unitList.find(v=> v.id == this.ruleForm.ruleDTO.measureUnitId && v.status == 0)
        if(unitItem) {
          return this.$message.warning(`"满${unitItem.name}有礼"已停用，请重新选择统计单位`);
        }
      }
      if(this.ruleForm.ruleDTO.prizeSettingType == '0'){
        if((this.ruleForm.ruleDTO.orderPaymentLimit <= 0 || this.ruleForm.ruleDTO.itemLimitCount <= 0) && this.ruleForm.ruleDTO.statisticType == 2){
          return this.$message.warning("请填写订单金额和商品件数");
        } else if(this.ruleForm.ruleDTO.orderPaymentLimit <= 0 && (this.ruleForm.ruleDTO.statisticType == 0 || this.ruleForm.ruleDTO.statisticType == 5)){
          return this.$message.warning("请正确填写订单金额");
        } else if(!this.ruleForm.ruleDTO.itemLimitCount && this.ruleForm.ruleDTO.statisticType == 1){
          return this.$message.warning("请填写商品件数");
        } else if(!this.ruleForm.ruleDTO.orderLimitCount && (this.ruleForm.ruleDTO.statisticType == 3 || this.ruleForm.ruleDTO.statisticType == 5 || this.ruleForm.ruleDTO.statisticType == 6)){
          return this.$message.warning("请填写订单笔数");
        }else if(this.ruleForm.ruleDTO.singleOrderPaymentLimit <= 0 && this.ruleForm.ruleDTO.statisticType == 6){
          return this.$message.warning("请正确填写订单金额");
        } else if(this.ruleForm.ruleDTO.measureUnitLimitCount <= 0 && this.ruleForm.ruleDTO.statisticType == 4){
          return this.$message.warning(`请填写商品${this.unitName}数`);
        }
      }
      let isPrizeNo = false
      let isTaskNo = false
      let itemLimitCountArr = []
      let orderPaymentLimit = []
      let itemLimitNumberArr = []
      let singleOrderPaymentLimitArr = []
      let measureUnitLimitCountArr = []
      this.pointActivityPrize.forEach(item=>{
        if(item.itemLimitCount){
          itemLimitCountArr.push(item.itemLimitCount)
        }
        if(item.orderPaymentLimit){
          orderPaymentLimit.push(item.orderPaymentLimit)
        }
        if(item.orderLimitCount){
          itemLimitNumberArr.push(item.orderLimitCount)
        }
        if(item.singleOrderPaymentLimit){
          singleOrderPaymentLimitArr.push(item.singleOrderPaymentLimit)
        }
        if(item.measureUnitLimitCount){
          measureUnitLimitCountArr.push(item.measureUnitLimitCount)
        }
        item.prizeTable.forEach(it=>{
          if(!it.prizeType||!it.title||!it.totalAmount||!it.logo){
            isPrizeNo = true
          }
        })
        if(this.ruleForm.ruleDTO.prizeSettingType == '1'){
          if((item.orderPaymentLimit <= 0 || item.itemLimitCount <= 0) && this.ruleForm.ruleDTO.statisticType == 2){
            isTaskNo = "请填写订单金额和商品件数"
          } else if(item.orderPaymentLimit <= 0 && (this.ruleForm.ruleDTO.statisticType == 0 || this.ruleForm.ruleDTO.statisticType == 5)) {
            isTaskNo = "请正确填写订单金额"
          } else if(!item.itemLimitCount && this.ruleForm.ruleDTO.statisticType == 1) {
            isTaskNo = "请填写商品件数"
          } else if(!item.orderLimitCount && (this.ruleForm.ruleDTO.statisticType == 3 || this.ruleForm.ruleDTO.statisticType == 5 || this.ruleForm.ruleDTO.statisticType == 6)) {
            isTaskNo = "请填写订单笔数"
          } else if(item.measureUnitLimitCount <= 0 && this.ruleForm.ruleDTO.statisticType == 4) {
            isTaskNo = `请填写商品${this.unitName}数`
          }
        }
      })
      // if(orderPaymentLimit.length >0 && orderPaymentLimit.length < this.pointActivityPrize.length && this.ruleForm.ruleDTO.prizeSettingType == 1){
      //   return this.$message.warning("当阶梯消费门槛设置订单金额时，全部阶梯都需要设置订单金额");
      // }
      // if(itemLimitCountArr.length>0&&itemLimitCountArr.length<this.pointActivityPrize.length&&this.ruleForm.ruleDTO.prizeSettingType == 1){
      //   return this.$message.warning("当阶梯消费门槛设置商品件数时，全部阶梯都需要设置商品件数");
      // }
      if(orderPaymentLimit.length>0&&!this.isMonotonicIncreasing(orderPaymentLimit)&&this.ruleForm.ruleDTO.prizeSettingType == 1){
        return this.$message.warning('阶梯订单金额需逐级递增')
      }
      if(itemLimitCountArr.length>0&&!this.isMonotonicIncreasing(itemLimitCountArr)&&this.ruleForm.ruleDTO.prizeSettingType == 1){
        return this.$message.warning('阶梯商品件数需逐级递增')
      }
      if(itemLimitNumberArr.length>0&&!this.isMonotonicIncreasing(itemLimitNumberArr)&&this.ruleForm.ruleDTO.prizeSettingType == 1){
        return this.$message.warning('阶梯订单笔数需逐级递增')
      }
      if(measureUnitLimitCountArr.length > 0 && !this.isMonotonicIncreasing(measureUnitLimitCountArr) && this.ruleForm.ruleDTO.prizeSettingType == 1){
        return this.$message.warning(`阶梯商品${this.unitName}数需逐级递增`)
      }

      if(isPrizeNo){
        return this.$message.warning("请完善奖品信息");
      }
      if(isTaskNo){
        return this.$message.warning(isTaskNo || "请完善阶梯消费门槛");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListFor.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      } else {
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
   
      delete obj.goShopSetting
      delete obj.goShopAppId
      delete obj.goShopUrl

      obj.templateJson = this.templateJson;
      obj.allowLevel = this.ruleForm.partner && this.ruleForm.partner.length ? this.ruleForm.partner.join(",") : ""; //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,

      // 1.44迭代
      obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow
      obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay
      obj.ruleDTO.orderCompleteLimitCount = this.ruleForm.orderCompleteLimitCount
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount
      obj.ruleDTO.orderCompleteLimitPayment = this.ruleForm.orderCompleteLimitPayment
      obj.ruleDTO.orderCompleteMaxPayment = this.ruleForm.orderCompleteMaxPayment
      obj.ruleDTO.lastOrderCompleteTimeType = this.ruleForm.lastOrderCompleteTimeType
      if(obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay = this.ruleForm.lastOrderCompleteStartDay
        obj.ruleDTO.lastOrderCompleteEndDay = this.ruleForm.lastOrderCompleteEndDay
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime = this.ruleForm.lastOrderCompleteStartTime
      }
      obj.ruleDTO.lastOrderCompleteTimeType = this.ruleForm.lastOrderCompleteTimeType
      // 删除根级别的重复字段
      delete obj.firstOpenCardTimeType
      delete obj.openCardBeforeDay
      delete obj.openCardFollow
      delete obj.orderCompleteLimitCount
      delete obj.orderCompleteMaxCount
      delete obj.orderCompleteLimitPayment
      delete obj.orderCompleteMaxPayment
      delete obj.lastOrderCompleteTimeType
      delete obj.lastOrderCompleteStartDay
      delete obj.lastOrderCompleteEndDay
      delete obj.lastOrderCompleteStartTime
      delete obj.lastOrderCompleteEndTime
      // if()
      // 1.14迭代 这里提交
      obj.ruleDTO.isCheckOpenCardTime = this.actMember == 2 ? this.ruleForm.ruleDTO.isCheckOpenCardTime : false
      obj.ruleDTO.openCardStartTime = this.actMember == 2 ? this.ruleForm.ruleDTO.openCardStartTime : ''
      obj.ruleDTO.openCardEndTime = this.actMember == 2 ? this.ruleForm.ruleDTO.openCardEndTime : ''
      obj.ruleDTO.cusType = this.actMember == 2 ? this.ruleForm.ruleDTO.cusType : 0
      obj.ruleDTO.plusObject = this.ruleForm.ruleDTO.plusObject
      obj.ruleDTO.cusTemplateJSON = this.cusTemplateJSON
      obj.ruleDTO.isForceRemind = this.isForceRemind
      obj.isKeyActivity = this.isKeyActivity
      obj.placementPosition = this.placementPosition.join(",")

      obj.ruleDTO.shareIntroduce = this.ruleForm.shareIntroduce
      obj.ruleDTO.sharePic = this.ruleForm.sharePic
      obj.ruleDTO.shareTitle = this.ruleForm.shareTitle


      obj.priceType = this.ruleForm.radio
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0
      obj.itemList = this.itemListFor //曝光商品集合
      obj.templateId = this.templateId
      obj.ruleDTO.stepList = []
      obj.pointActivityPrizeDTOList = []
      obj.ruleDTO.orderCondition = this.ruleForm.orderCondition
      if(obj.ruleDTO.prizeSettingType == 0) {
        obj.ruleDTO.exchangeType = 0
        obj.ruleDTO.exchangeNumber = ""
      }
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork)
      // 处理下单多店铺
      if(!this.ruleForm.ruleDTO.measureUnitId&&this.ruleForm.ruleDTO.filterType==0) {
        obj.ruleDTO.sellerSkuList = []
      }
      // showProductConditon字段转换：前端false(不勾选)=展示商品→后端true；前端true(勾选)=不展示→后端false
      obj.ruleDTO.showProductConditon = !this.ruleForm.ruleDTO.showProductConditon;
      if(obj.ruleDTO.sellerSkuList.length) {
        obj.ruleDTO.sellerSkuList.forEach((item)=>{
          delete item.itemList
        })
      }
      if (this.pointActivityPrize.length >= 1 && this.pointActivityPrize[0].prizeTable[0].prizeType) {
        this.pointActivityPrize.forEach(item => {
          let stepListItem = {
            taskIndex: item.taskIndex,
            itemLimitCount: item.itemLimitCount,
            orderLimitCount: item.orderLimitCount,
            measureUnitLimitCount: item.measureUnitLimitCount,
            orderPaymentLimit: item.orderPaymentLimit,
            orderCountType: this.ruleForm.ruleDTO.orderCountType,
            singleOrderPaymentLimit: item.singleOrderPaymentLimit,
          }
          obj.ruleDTO.stepList.push(stepListItem)
          item.prizeTable.forEach(it => {
            it.taskIndex = item.taskIndex
            // 提交地址限制：数组转逗号分隔字符串
            if (it.prizeType == 3 && Array.isArray(it.commitAddressLimit)) {
              it.commitAddressLimit = it.commitAddressLimit.join(',')
            }
            obj.pointActivityPrizeDTOList.push(it)
          })
        })
      }

      if (this.actMember == 1) {
        obj.allowLevel = "-1"
      } else if (this.actMember == 3) {
        obj.allowLevel = "99"
        obj.crowdIds = this.peopleSelected.join(",")
      } else if (this.actMember == 2) {
        obj.allowLevel = this.ruleForm.partner && this.ruleForm.partner.length ? this.ruleForm.partner.join(",") : "";
        if (obj.allowLevel == '-1') {
          //会员等级设置
          let list = ['-1', '0']
          this.levelList.forEach((item, index) => {
            let num = index + 1
            list.push(num)
          })
          obj.allowLevel = list.join(",")
        }
      }

      if(obj.ruleDTO.multiShopSkuType == 0) {
        obj.ruleDTO.skuBelongVenderId = this.itemListFor && this.itemListFor.length ? this.itemListFor[0].belongVenderId : ""
      } else {
        obj.ruleDTO.skuBelongVenderId = ""
      }
      // V2.5 => 复制，去除id和旧的模板数据
      if (this.activityData.isCopy) {
        this.ids = "";
        delete obj.templateJson
      }
      if (this.checked == true || this.isDraft) {
          if (this.isDraft) {
            obj.status = 5
          } else {
            // 保存正式活动不需要status
            if (obj.status) {
              delete obj.status
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id
          }else if(this.ids){
            obj.id = this.valueRow.id
            obj.pointActivityId = this.valueRow.id
          }
          if (this.activityData.isCopy) {
            delete obj.id
            delete obj.pointActivityId 
          }
          if(this.activityData.isStart){
              obj.activityId = this.valueRow.id
              if(this.pointActivityPrizeJSON == JSON.stringify(this.pointActivityPrize)){
                // delete obj.ruleDTO.stepList
                delete obj.pointActivityPrizeDTOList
              }else{
                obj.prizes = obj.pointActivityPrizeDTOList.map((item) => {
                  const prize = {
                    ...item,
                    prizeId: item.id,
                  }
                  // 提交地址限制：数组转逗号分隔字符串
                  if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                    prize.commitAddressLimit = item.commitAddressLimit.join(',')
                  }
                  return prize;
                })
              }
            updateCommon(obj).then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！")
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => { });

            return
          }
          fullGiftSave(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！")
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => { });
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        fullGiftDetail(id)
          .then((res) => {
            this.isEdit = true
            res.data.partner = []
            let data = res.data;

            // this.ruleForm = data;
            this.actEndTime = res.data.endTime
            this.activityStartTime = res.data.startTime ? res.data.startTime : null
            this.activityEndTime = res.data.endTime ? res.data.endTime : null
            let keysArr = Object.keys(data.ruleDto)
            keysArr.forEach(item=>{
              this.ruleForm.ruleDTO[item] = data.ruleDto[item]
            })
            this.ruleForm.ruleDTO.mergeOrder = this.ruleForm.ruleDTO.mergeOrder || false;
            this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
            this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
            this.ruleForm.sharePic = res.data.ruleDto.sharePic;
            this.ruleForm.partner = res.data.allowLevel.split(",");
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 学生身份
            this.ruleForm.studentSatus = res.data.studentSatus || "";
            if (res.data.allowLevel == "99") {
              this.peopleSelected = res.data.crowdIds.split(",")
              this.actMember = "3"
            } else if (res.data.allowLevel == "-1") {
              this.actMember = "1"
              this.ruleForm.partner = ["-1"]
            } else {
              this.actMember = "2"
              if (res.data.allowLevel.indexOf('-1') != -1) {
                this.ruleForm.partner = ["-1"]
              } else {
                this.ruleForm.partner = res.data.allowLevel.split(",");
              }
            }
            if(this.ruleForm.ruleDTO.cusType != 0){
              this.actMember = "2"
            }
            // 1.44
            this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType || 0
            this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
            this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow
            this.ruleForm.orderCompleteLimitCount = res.data.ruleDto.orderCompleteLimitCount
            this.ruleForm.orderCompleteMaxCount = res.data.ruleDto.orderCompleteMaxCount
            this.ruleForm.orderCompleteLimitPayment = res.data.ruleDto.orderCompleteLimitPayment
            this.ruleForm.orderCompleteMaxPayment = res.data.ruleDto.orderCompleteMaxPayment
            this.ruleForm.lastOrderCompleteTimeType = res.data.ruleDto.lastOrderCompleteTimeType || 0
            this.ruleForm.lastOrderCompleteStartDay = res.data.ruleDto.lastOrderCompleteStartDay
            this.ruleForm.lastOrderCompleteEndDay = res.data.ruleDto.lastOrderCompleteEndDay
            this.ruleForm.lastOrderCompleteStartTime = res.data.ruleDto.lastOrderCompleteStartTime
            this.ruleForm.lastOrderCompleteEndTime = res.data.ruleDto.lastOrderCompleteEndTime
            if(this.ruleForm.ruleDTO.cusType == 3&&res.data.ruleDto.orderCondition) {
              this.ruleForm.orderCondition = res.data.ruleDto.orderCondition
              // 老客指定条件 - 回显
              if (this.ruleForm.ruleDTO.cusType == 3) {
                if (this.ruleForm.orderCondition.skuIds.length) {
                  getTaobaoItemListSku({
                    current: 1,
                    size: this.ruleForm.orderCondition.skuIds.length,
                    skuIds: this.ruleForm.orderCondition.skuIds,
                  })
                    .then((result) => {
                      this.newOrderWareList = result.data.records;
                    })
                    .catch((err) => {
                    });
                }
              }
            }

            // 1.14迭代 这里回显

            this.ruleForm.ruleDTO.isCheckOpenCardTime = res.data.ruleDto.isCheckOpenCardTime
            this.ruleForm.ruleDTO.openCardStartTime = res.data.ruleDto.openCardStartTime
            this.ruleForm.ruleDTO.openCardEndTime = res.data.ruleDto.openCardEndTime
            this.ruleForm.ruleDTO.plusObject = res.data.ruleDto.plusObject //plus会员
            this.ruleForm.ruleDTO.exchangeNumber = res.data.ruleDto.exchangeNumber || ""; // 兑换奖品限制-每个阶梯仅能领取一个
            this.ruleForm.ruleDTO.exchangeType = res.data.ruleDto.exchangeType || 0; // 兑换奖品限制-仅可兑换一次
            this.ruleForm.ruleDTO.claimTiming = res.data.ruleDto.claimTiming || 0; // 0-先领取后发放，1-达到要求后立即领取并发放
            this.ruleForm.ruleDTO.notShowPrizeValue = res.data.ruleDto.notShowPrizeValue || false; //C端不显示奖品价值
            // 后端字段showProductConditon：true/null展示(复选框不勾选) false不展示(复选框勾选)，转换为前端绑定值
            // 后端返回true/null → 前端false=不勾选；后端返回false → 前端true=勾选
            this.ruleForm.ruleDTO.showProductConditon = res.data.ruleDto.showProductConditon == false ? true : false;

            if(res.data.ruleDto.isForceRemind ){
              this.isForceRemind = res.data.ruleDto.isForceRemind 
            }
            if(res.data.isKeyActivity ){ 
              this.isKeyActivity = res.data.isKeyActivity 
            }
            if(res.data.placementPosition ){
              this.placementPosition = res.data.placementPosition.split(",")
            }

            if(res.data.ruleDto.cusTemplateJSON){
              this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
            }
            this.templateId = res.data.templateId
            // 回显下单店铺
            if(res.data.ruleDto.venderIds&&res.data.ruleDto.venderIds.length) {
              this.ruleForm.ruleDTO.venderIds = res.data.ruleDto.venderIds;
            }
            if(!this.ruleForm.ruleDTO.venderIds) {
              this.ruleForm.ruleDTO.venderIds = [this.venderId]
            }
            if(!this.ruleForm.ruleDTO.sellerSkuList||this.ruleForm.ruleDTO.sellerSkuList.length == 0) {
              this.ruleForm.ruleDTO.sellerSkuList = [{
                venderId: this.venderId,
                skuIds: [],
                itemList: [],
              }]
            }
            this.getShopStatus(this.ruleForm.ruleDTO.venderIds);
            // 回显指定计量单位商品
            if(data.ruleDto.statisticType == 4) {
              const skuIdList = data.ruleDto.skuIdList || []
              if(skuIdList.length) {
                this.ruleForm.ruleDTO.sellerSkuList = [{
                  skuIds: [],
                  itemList: [],
                  venderId: [this.venderId]
                }]
                this.skuIdListLoading = true
                unitSkuPage({
                  measureUnitId: data.ruleDto.measureUnitId,
                  skuIdStr: skuIdList.join(","),
                  current: 1,
                  size: (data.ruleDto.itemList && data.ruleDto.itemList.length) || 999,
                  venderId: this.venderId
                }).then(result=>{
                  this.skuIdListLoading = false
                  this.ruleForm.ruleDTO.sellerSkuList[0].itemList = result.data.records;
                  this.ruleForm.ruleDTO.sellerSkuList[0].skuIds = result.data.records.map(v=> v.skuId);
                }).catch(err=>{
                  this.skuIdListLoading = false
                })
              } else if(data.ruleDto.sellerSkuList.length){
                // 回显指定计量单位商品：除了统计单位不是满额有礼外的
                this.ruleForm.ruleDTO.sellerSkuList = data.ruleDto.sellerSkuList;
                let reqFn = []
                this.ruleForm.ruleDTO.sellerSkuList.forEach(item=>{
                  reqFn.push(unitSkuPage({
                    measureUnitId: data.ruleDto.measureUnitId,
                    skuIdStr: item.skuIds.join(","),
                    current: 1,
                    size: (item.skuIds && item.skuIds.length) || 999,
                    venderId: item.venderId
                  }))
                })
                Promise.all(reqFn).then((res)=>{
                  // 处理返回结果，将接口数据映射到对应item
                  this.ruleForm.ruleDTO.sellerSkuList.forEach((item, index) => {
                    item.itemList = res[index].data.records || [];
                    // 补充商品信息到itemList
                    item.itemList.forEach(skuItem => {
                      skuItem.wareTitle = skuItem.title;
                      skuItem.isAdd = skuItem.isAddCart;
                    });
                  });
                })
              }
            } else {
              if(this.ruleForm.ruleDTO.itemList&&this.ruleForm.ruleDTO.itemList.length>0) {
                this.ruleForm.ruleDTO.sellerSkuList = [{
                  skuIds: [],
                  itemList: [],
                  venderId: [this.venderId]
                }]
                this.ruleForm.ruleDTO.sellerSkuList[0].skuIds = data.ruleDto.itemList.map(v=> v.skuId);
                this.ruleForm.ruleDTO.sellerSkuList[0].itemList = data.ruleDto.itemList;
                this.ruleForm.ruleDTO.sellerSkuList[0].itemList.forEach(item=>{
                  item.wareTitle = item.title
                  item.isAdd = item.isAddCart
                })
              } else if(data.ruleDto.sellerSkuList&&data.ruleDto.sellerSkuList.length>0) {
                this.ruleForm.ruleDTO.sellerSkuList = data.ruleDto.sellerSkuList;
                let reqFn = []
                this.ruleForm.ruleDTO.sellerSkuList.forEach(item=>{
                  reqFn.push(getTaobaoItemListSku({
                    current: 1,
                    size: item.skuIds.length,
                    venderId: item.venderId,
                    skuIdStr: item.skuIds.join(",")
                  }))
                })
                Promise.all(reqFn).then((res)=>{
                  // 处理返回结果，将接口数据映射到对应item
                  this.ruleForm.ruleDTO.sellerSkuList.forEach((item, index) => {
                    item.itemList = res[index].data.records || [];
                    // 补充商品信息到itemList
                    item.itemList.forEach(skuItem => {
                      skuItem.wareTitle = skuItem.title;
                      skuItem.isAdd = skuItem.isAddCart;
                    });
                  });
                })
              }
            }
            // 优化：实物奖品可以复制
            this.ruleForm.ruleDTO.prizeSettingType = res.data.ruleDto.prizeSettingType
            this.pointActivityPrize = []
            this.ruleForm.ruleDTO.stepList.forEach(item=>{
              let stepData = {
                taskIndex:item.taskIndex,
                itemLimitCount:item.itemLimitCount?item.itemLimitCount:'',
                orderLimitCount: item.orderLimitCount ? item.orderLimitCount : "",
                measureUnitLimitCount: item.measureUnitLimitCount ? item.measureUnitLimitCount : "",
                orderPaymentLimit:item.orderPaymentLimit?item.orderPaymentLimit:'',
                orderCountType:item.orderCountType,
                singleOrderPaymentLimit: item.singleOrderPaymentLimit ? item.singleOrderPaymentLimit : "",
                prizeTable:[]
              }
              res.data.pointActivityPrizeDTOList.forEach(it=>{
                if(it.taskIndex == stepData.taskIndex){
                  // 提交地址限制回显：逗号分隔字符串转数字数组
                  if (it.prizeType == 3) {
                    if (it.commitAddressLimit) {
                      it.commitAddressLimit = typeof it.commitAddressLimit === 'string'
                        ? it.commitAddressLimit.split(',').map(Number)
                        : it.commitAddressLimit;
                    } else {
                      it.commitAddressLimit = [0];
                    }
                  }
                  stepData.prizeTable.push(it)
                }
              })
              this.pointActivityPrize.push(stepData)
            })
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              // 回显
              this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
              this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
              this.selectGoodsArr = res.data.itemList;
              this.mainImagelist = res.data.itemList;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = res.data.ruleDescription
              if(this.pointActivityPrize.length == 0) {
                this.prizeSettingTypeChange()
              }
              this.pointActivityPrizeJSON = JSON.stringify(this.pointActivityPrize)
            }else{
              this.pointActivityPrize.forEach(item=>{
                if(item.prizeTable.some((it)=>it.prizeType == 3)) {
                  item.prizeTable = item.prizeTable.filter(v=>v.prizeType == 3);
                  item.prizeTable.forEach(prize=>{
                    delete prize.id
                  })
                } else {
                  item.prizeTable = [{
                    prizeType:'',
                    price:'',
                    logo:'',
                    title:'',
                    totalAmount:''
                  }]
                }
              })
              // this.ruleForm.ruleDTO.prizeSettingType = 0
            }
            // 领奖限制：在prizeSettingTypeChange()之后设置，避免被重置为0
            this.ruleForm.ruleDTO.winLimitType = Number(res.data.ruleDto.winLimitType) === 1 ? 1 : 0;
            this.ruleForm.ruleDTO.sendDay = res.data.ruleDto.sendDay?res.data.ruleDto.sendDay:''
            if(res.data.ruleDto.customerPaperwork){
              this.customerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork)
            }
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = ""
            }
            if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(this.ruleForm.ruleDTO.venderIds.length>0) {
                let index = this.ruleForm.ruleDTO.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  this.ruleForm.ruleDTO.venderIds.unshift(this.venderId)
                }
              }
            }
            
            // 统计类型历史数据回显
            if(this.ruleForm.ruleDTO.statisticType == null || this.ruleForm.ruleDTO.statisticType == undefined){
              if(this.ruleForm.ruleDTO.prizeSettingType == 0) {
                if(this.ruleForm.ruleDTO.orderPaymentLimit > 0 && this.ruleForm.ruleDTO.orderLimitCount > 0) {
                  this.ruleForm.ruleDTO.statisticType = 2
                } else if(this.ruleForm.ruleDTO.orderPaymentLimit > 0) {
                  this.ruleForm.ruleDTO.statisticType = 0
                } else {
                  this.ruleForm.ruleDTO.statisticType = 1
                }
              } else if(this.pointActivityPrize && this.pointActivityPrize.length > 0) {
                const item = this.pointActivityPrize[0]
                if(item.orderPaymentLimit > 0 && item.itemLimitCount > 0) {
                  this.ruleForm.ruleDTO.statisticType = 2
                } else if(item.orderPaymentLimit > 0) {
                  this.ruleForm.ruleDTO.statisticType = 0
                } else {
                  this.ruleForm.ruleDTO.statisticType = 1
                }
              }
            }
            
            this.templateJson = JSON.parse(res.data.templateJson);      
            
            this.joinTimeDisabled()
            this.joinTimeEndDisabled()
            this.getmeasureUnitPage()
            // this.winningRate = this.winningRate.toFixed(3);
            // console.log([String(res.data.startTime), String(res.data.endTime)]);
            // v2.5 => 复制不需要回显奖品和规则
          })
          .catch((res) => { });
      } else {
        // 新增-默认活动时间
        this.activityStartTime = this.$getDate(30)[0]
        this.activityEndTime = this.$getDate(30)[1]
          // this.$refs.informationForm.activityTimeChange();
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null
      this.activityEndTime = null
    },
    // 清空任务时间
    clearTaskTime() {
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 清空下单时间
    clearOrderTime() {
      this.taskForm.orderStartTime = "";
      this.taskForm.orderEndTime = "";
    },
    // 控制大于0 - 正数可包含小数点
    validateInput(value,min = null) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      newValue = newValue.replace(/^0+(\d)/, '$1');
      if(min != null){
        if(parseFloat(min) >= parseFloat(newValue)){
          newValue = parseFloat(min) + 0.01
        }
      }
      return newValue
    },
    validateInputNew(value,min = null) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999999) {
        newValue = '999999'; // 设置为最大值
      }
      if(min != null){
        if( parseInt(min) >= parseInt(newValue) ){
          newValue = parseInt(min) + 1
        }
      }
      return newValue
    },

    // 控制大于0 - 正数可包含小数点
    orderPaymentLimitValidateInput(value,itemIndex) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      newValue = newValue.replace(/^0+(\d)/, '$1');
      this.pointActivityPrize.forEach((item,index)=>{
          if(itemIndex>index){
            console.log("item=>>>",item)
            if(item.orderPaymentLimit&&(parseFloat(item.orderPaymentLimit) >= parseFloat(newValue)) ){
              newValue = ''
            }
          }
      })
      return newValue
    },
    itemLimitCountValidateInput(value,itemIndex) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999999) {
        newValue = '999999'; // 设置为最大值
      }
      this.pointActivityPrize.forEach((item,index)=>{
          if(itemIndex>index){
            console.log("item=>>>",item)
            if(item.itemLimitCount&&(parseInt(item.itemLimitCount) >= parseInt(newValue)) ){
              newValue = ''
            }
            if(item.orderLimitCount&&(parseInt(item.orderLimitCount) >= parseInt(newValue)) ){
              newValue = ''
            }
          }
      })
      return newValue
    },
    handleBlur() {
      if (Number(this.taskForm.amtLimit) === 0) {
        this.taskForm.amtLimit = '0';
      }
    },
    // 活动时间改变
    // activityTimeChange() {
    //   this.ruleForm.startTime = this.activityStartTime;
    //   this.ruleForm.endTime = this.activityEndTime;
    //   this.$nextTick(() => {
    //     if (this.ruleForm.endTime && this.ruleForm.startTime) {
    //       let nowTime = new Date().getTime();
    //       let start = new Date(this.ruleForm.startTime).valueOf();
    //       let end = new Date(this.ruleForm.endTime).valueOf();
    //       let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
    //       let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
    //       this.timeDay = Math.floor(
    //         Math.abs(
    //           new Date(this.ruleForm.endTime) -
    //           new Date(this.ruleForm.startTime)
    //         ) /
    //         1000 /
    //         60 /
    //         60 /
    //         24
    //       );
    //       //计算小时
    //       const date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
    //       const leave1 = date3 % (24 * 3600 * 1000);
    //       this.timeOut = Math.floor(leave1 / (3600 * 1000));
    //       // 查看不需要校验
    //       if (!this.backgroundOpacity) {
    //         if (start < nowTime) {
    //           if (this.ids) {
    //             this.disableTime = true;
    //           } else {
    //           }
    //         }
    //         if (end < nowTime) {
    //           this.$message.warning("结束时间不能小于当前时间");
    //         }
    //         if (end < start) {
    //           this.$message.warning("结束时间不能小于开始时间");
    //           return;
    //         }
    //         if (end > invalidateDate) {
    //           this.$message.warning("活动时间不能超过软件有效期，请重新选择");
    //           this.activityEndTime = null;
    //           this.ruleForm.endTime = null;
    //           return;
    //         }
    //         if (end > hdInvalidateDate) {
    //           this.$message.warning("活动时间不可超过互动数据授权有效期！");
    //           this.activityEndTime = null;
    //           this.ruleForm.endTime = null;
    //           return;
    //         }
    //       }
    //     }
    //   });
    // },

    // 选择礼品
    choosegifts() { },
    // 保留小数点后两位
    oninput2(val, $index, type = 1) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      let totalMemberBuyPercentage = 0
      this.prizeSettingList.forEach((item, index) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
        if (type === 2) {
          totalMemberBuyPercentage += Number(item.memberBuyPercentage);
        }
        if ($index == index) {
          item.isWrite = true
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // 入会且已购中奖率
      if (type === 2) {
        if (totalMemberBuyPercentage > 100) {
          val = String(100 - (totalMemberBuyPercentage - val));
        } else if (totalMemberBuyPercentage == 100) {
          if (val >= 100) {
            val = "100";
          } else {
            val = String(100 - (totalMemberBuyPercentage - val));
            if (val == 0) {
              val = "";
            }
          }
        }
      }

      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 商品组件回调
    selectGoodsChange(val) {
      this.goodsState = false;
      this.isShowSelectUnitGoods = false;
      if (val) {
        let valArr = [];
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        this.selectGoodsSkuList = val;
        this.ruleForm.ruleDTO.sellerSkuList.forEach((item)=>{
          if(item.venderId==this.curretnVenderId) {
            item.skuIds = valArr;
            item.itemList = val
          }
        })
        console.log(this.ruleForm.ruleDTO.sellerSkuList)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goToMeasureUnitText{
  color: #3159FF;
  cursor: pointer;
}
:deep(.titleBox){
  margin: 16px 0;
}
.statisticType-tips{
  margin-left: 8px;
  color: red;
}
.taskBox{
  background-color: #fff;
  border: 1px solid rgb(240, 240, 240);
  padding: 40px 10px 10px 10px;
  margin-bottom: 10px;
  position: relative;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;

  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;

    span {
      color: #ccc;
      cursor: pointer;
    }

    .name {
      color: #333;
      cursor: default;
    }
  }

  .step {
    padding: 30px 24px 0;

    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }

  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;

    .itemList {
      display: flex;

      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;

        &:hover {

          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }

        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;

          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }

          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }

          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;

          &:hover {
            .mask {
              opacity: 1;
            }
          }

          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;

            .img {
              max-width: 130px;
              margin: 0 auto 30px;

              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }

              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;

    .zd {
      width: 360px;
    }

    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }

    .lastTime {
      margin-left: 20px;
      font-size: 14px;

      i {
        color: #ccc;
      }
    }

    .limit {
      display: flex;
      flex-direction: column;

      p {
        margin: 0;

        &:nth-child(2) {
          margin: 16px 0;
        }
      }

      .c {
        color: #fe4d45;
      }

      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }

        color: #999;
      }

      /deep/ .el-input {
        margin: 0 6px;
      }
    }

    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }

    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;

      i {
        color: #fe8f8a;
        opacity: 0.7;
      }

      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }

    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }

    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;

      p {
        margin: 0;
      }

      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }

    .set {
      display: inline-block;
      margin-top: 30px;
    }

    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;

      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }

    .s {
      color: #fe4d45;
      cursor: pointer;
    }

    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #fe4d45;
      color: #fe4d45;
      transition: all 0.2s;

      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }

    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;

      &:hover {
        opacity: 0.9;
      }
    }

    .rule-tip {
      margin-top: 8px;
    }

    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }
}

.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;

    &:hover {

      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }

    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;

      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }

      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }

      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }

    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }

    &:hover {
      .queryIdIMG {
        display: block;
      }

      .mask {
        opacity: 1;
      }
    }

    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;

      .img {
        max-width: 130px;
        margin: 0 auto 30px;

        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }

        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }

  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}

.miniAppPic {
  position: relative;

  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;

    i {
      font-size: 30px;
      color: #909399;
    }
  }

  .top {
    position: relative;
    left: 8px;
    display: flex;

    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;

      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }

    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }

  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;

    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }

    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

.task-wrap {
  display: flex;
  align-items: center;

  &-radio {
    margin-right: 10px;
  }
}

.book-good-wrap {
  display: flex;
  align-items: center;
}

.tip-red {
  color: red;
}

.task-tip-wrap {
  padding-right: 10%;
}

.skuType-label {
  /deep/ .el-form-item__label {
    padding-right: 3px;
  }
}
.grey-color {
  color: #ccc;
}
.shoptitle-label {
  margin-right: 12px;
  min-width: 60px;
  text-align: right;
  font-size: 12px !important;
}
.mb8 {
  margin-bottom: 8px;
}
</style>
<style lang="scss">
.createPlayStep {

  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  //   .el-step__line {
  //     background-color: #fe4d45;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  // }
  // .el-step__title.is-process {
  //   color: #fe4d45;
  // }
  // .el-step__title.is-success {
  //   color: #fe4d45;
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }

  .el-step__head.is-process {
    position: absolute;
  }

  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }

  .el-step {
    position: relative;
  }
}

.task-btn-wrap {
  margin-bottom: 16px;
}

.task-tip {
  margin-bottom: 16px;
}

.rule_box {
  width: 860px;
  // height: 217px;
  margin-top: 9px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;

  &_middle {
    padding-top: 10px;
  }

  &_content {
    padding: 0 15px;

    img {
      display: inline-block;
      float: left;
      position: absolute;
      width: 14px;
      height: 14px;
      color: #ffffff;
      margin: 9px 4px 0 3px;
    }

    p {
      padding-left: 21px;
    }
  }
}
</style>